import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, HostListener, Injectable, Inject, Directive, HostBinding, NgModule } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@angular/router';
import { Router, RouterModule } from '@angular/router';
import SwiperCore, { Navigation, Pagination, A11y, Lazy } from 'swiper/core';
import * as i2 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import { SwiperModule } from 'swiper/angular';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCheckSquare, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faClone, faCoffee, faComments, faGlobe, faGlobeAmericas, faHeart as faHeart$1, faFunnelDollar, faLaptop, faMapMarked, faPen, faPhoneVolume, faPlus, faSackDollar, faSquare, faUser, faUsers, faUsersClass, faUserTag, faTags, faTrashAlt, faUmbrellaBeach, faWrench } from '@fortawesome/pro-solid-svg-icons';
import { faCircle, faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import { faHeart, faMinus, faPlus as faPlus$1, faShoppingCart, faUserCircle } from '@fortawesome/pro-light-svg-icons';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@fortawesome/angular-fontawesome';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from 'swiper/angular';

function ListButtonComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.status);
} }
const _c0 = function () { return ["fas", "pen"]; };
function ListButtonComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelement(1, "fa-icon", 7);
    ɵngcc0.ɵɵelementStart(2, "span", 8);
    ɵngcc0.ɵɵtext(3, "Edit");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c0));
} }
const _c1 = function () { return ["fas", "chevron-down"]; };
function AccordionBasicComponent_div_1_fa_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 7);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c1));
} }
const _c2 = function () { return ["fas", "chevron-up"]; };
function AccordionBasicComponent_div_1_fa_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 7);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c2));
} }
const _c3 = function (a0) { return { "active": a0 }; };
const _c4 = function (a0) { return { "border-color": a0 }; };
function AccordionBasicComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵlistener("click", function AccordionBasicComponent_div_1_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const tab_r1 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.toggleContent(tab_r1); });
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵtemplate(5, AccordionBasicComponent_div_1_fa_icon_5_Template, 1, 2, "fa-icon", 5);
    ɵngcc0.ɵɵtemplate(6, AccordionBasicComponent_div_1_fa_icon_6_Template, 1, 2, "fa-icon", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("tab tab--", i_r2, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c3, tab_r1.isActive))("ngStyle", ɵngcc0.ɵɵpureFunction1(13, _c4, ctx_r0.textColor));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(tab_r1.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !tab_r1.isActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", tab_r1.isActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c3, tab_r1.isActive))("ngStyle", ɵngcc0.ɵɵpureFunction1(17, _c4, ctx_r0.lineColor + " !important"))("innerHTML", tab_r1.body, ɵngcc0.ɵɵsanitizeHtml);
} }
const _c5 = function (a0) { return { "color": a0 }; };
const _c6 = function () { return ["fal", "plus"]; };
function AccordionTabGroupComponent_ng_container_1_fa_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 6);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c6));
} }
const _c7 = function () { return ["fal", "minus"]; };
function AccordionTabGroupComponent_ng_container_1_fa_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 6);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c7));
} }
function AccordionTabGroupComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵlistener("click", function AccordionTabGroupComponent_ng_container_1_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const tab_r1 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.toggleContent(tab_r1); });
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵtemplate(5, AccordionTabGroupComponent_ng_container_1_fa_icon_5_Template, 1, 2, "fa-icon", 4);
    ɵngcc0.ɵɵtemplate(6, AccordionTabGroupComponent_ng_container_1_fa_icon_6_Template, 1, 2, "fa-icon", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "div", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("tab tab--", i_r2, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c3, tab_r1.isActive))("ngStyle", ɵngcc0.ɵɵpureFunction1(13, _c4, ctx_r0.textColor));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(tab_r1.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !tab_r1.isActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", tab_r1.isActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c3, tab_r1.isActive))("ngStyle", ɵngcc0.ɵɵpureFunction1(17, _c4, ctx_r0.lineColor + " !important"))("innerHTML", tab_r1.body, ɵngcc0.ɵɵsanitizeHtml);
} }
const _c8 = function (a1) { return ["fas", a1]; };
function AlertBannerComponent_div_0_ul_2_li_1_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 9);
} if (rf & 2) {
    const item_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction1(1, _c8, item_r4.icon));
} }
function AlertBannerComponent_div_0_ul_2_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 7);
    ɵngcc0.ɵɵtemplate(2, AlertBannerComponent_div_0_ul_2_li_1_fa_icon_2_Template, 1, 3, "fa-icon", 8);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", item_r4.href, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r4.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r4.title);
} }
function AlertBannerComponent_div_0_ul_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 5);
    ɵngcc0.ɵɵtemplate(1, AlertBannerComponent_div_0_ul_2_li_1_Template, 5, 3, "li", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.options.ulLeft);
} }
function AlertBannerComponent_div_0_ul_4_li_1_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 9);
} if (rf & 2) {
    const item_r8 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction1(1, _c8, item_r8.icon));
} }
function AlertBannerComponent_div_0_ul_4_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 7);
    ɵngcc0.ɵɵtemplate(2, AlertBannerComponent_div_0_ul_4_li_1_fa_icon_2_Template, 1, 3, "fa-icon", 8);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", item_r8.href, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r8.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r8.title);
} }
function AlertBannerComponent_div_0_ul_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 10);
    ɵngcc0.ɵɵtemplate(1, AlertBannerComponent_div_0_ul_4_li_1_Template, 5, 3, "li", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.options.ulRight);
} }
function AlertBannerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵtemplate(2, AlertBannerComponent_div_0_ul_2_Template, 2, 1, "ul", 2);
    ɵngcc0.ɵɵelement(3, "div", 3);
    ɵngcc0.ɵɵtemplate(4, AlertBannerComponent_div_0_ul_4_Template, 2, 1, "ul", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("alert-banner ", ctx_r0.options.className, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.options == null ? null : ctx_r0.options.ulLeft);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.options.text, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.options.ulRight);
} }
const _c9 = function (a0) { return [a0]; };
function BreadcrumbsComponent_li_2_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "a", 5);
} if (rf & 2) {
    const crumb_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(2, _c9, crumb_r1.href))("innerHTML", crumb_r1.title, ɵngcc0.ɵɵsanitizeHtml);
} }
function BreadcrumbsComponent_li_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 6);
} if (rf & 2) {
    const crumb_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", crumb_r1.title, ɵngcc0.ɵɵsanitizeHtml);
} }
function BreadcrumbsComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_li_2_a_1_Template, 1, 4, "a", 3);
    ɵngcc0.ɵɵtemplate(2, BreadcrumbsComponent_li_2_span_2_Template, 1, 1, "span", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c3, !crumb_r1.href));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", crumb_r1.href);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !crumb_r1.href);
} }
function CheckboxFormGroupComponent_div_0_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const title_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    ɵngcc0.ɵɵclassMapInterpolate1("title", i_r5, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(title_r4);
} }
function CheckboxFormGroupComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, CheckboxFormGroupComponent_div_0_div_1_span_1_Template, 2, 4, "span", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.header);
} }
const _c10 = function () { return ["fas", "check-square"]; };
function CheckboxFormGroupComponent_div_0_div_2_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 15);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(2, _c10))("fixedWidth", true);
} }
const _c11 = function () { return ["fas", "square"]; };
function CheckboxFormGroupComponent_div_0_div_2_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 16);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(2, _c11))("fixedWidth", true);
} }
function CheckboxFormGroupComponent_div_0_div_2_div_5_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext();
    const j_r16 = ctx_r18.index;
    const field_r15 = ctx_r18.$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("cb-text label", j_r16 + 1, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(field_r15.label);
} }
function CheckboxFormGroupComponent_div_0_div_2_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CheckboxFormGroupComponent_div_0_div_2_div_5_ng_container_1_span_1_Template, 2, 4, "span", 20);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r15 = ctx.$implicit;
    const j_r16 = ctx.index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r15.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("cb-text field", j_r16 + 1, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(field_r15.value);
} }
function CheckboxFormGroupComponent_div_0_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtemplate(1, CheckboxFormGroupComponent_div_0_div_2_div_5_ng_container_1_Template, 4, 5, "ng-container", 18);
    ɵngcc0.ɵɵelement(2, "span", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const box_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", box_r6.fields);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", box_r6.body, ɵngcc0.ɵɵsanitizeHtml);
} }
function CheckboxFormGroupComponent_div_0_div_2_div_6_ng_container_1_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext();
    const j_r22 = ctx_r24.index;
    const field_r21 = ctx_r24.$implicit;
    const i_r7 = ɵngcc0.ɵɵnextContext(2).index;
    ɵngcc0.ɵɵpropertyInterpolate("for", "field" + (j_r22 + 1) + "_" + i_r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(field_r21.label);
} }
function CheckboxFormGroupComponent_div_0_div_2_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CheckboxFormGroupComponent_div_0_div_2_div_6_ng_container_1_label_1_Template, 2, 2, "label", 22);
    ɵngcc0.ɵɵelement(2, "input", 23);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r21 = ctx.$implicit;
    const j_r22 = ctx.index;
    const i_r7 = ɵngcc0.ɵɵnextContext(2).index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r21.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("name", "field", j_r22 + 1, "");
    ɵngcc0.ɵɵpropertyInterpolate("id", "field" + (j_r22 + 1) + "_" + i_r7);
    ɵngcc0.ɵɵproperty("type", field_r21.type)("value", field_r21.value);
    ɵngcc0.ɵɵattribute("placeholder", field_r21.placeholder);
} }
function CheckboxFormGroupComponent_div_0_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtemplate(1, CheckboxFormGroupComponent_div_0_div_2_div_6_ng_container_1_Template, 3, 6, "ng-container", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const box_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", box_r6.fields);
} }
function CheckboxFormGroupComponent_div_0_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵlistener("click", function CheckboxFormGroupComponent_div_0_div_2_div_8_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r30); const box_r6 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ctx_r28.toggleEdit("open", box_r6); });
    ɵngcc0.ɵɵtext(1, "Edit");
    ɵngcc0.ɵɵelementEnd();
} }
function CheckboxFormGroupComponent_div_0_div_2_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 25);
    ɵngcc0.ɵɵlistener("click", function CheckboxFormGroupComponent_div_0_div_2_div_9_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(); const box_r6 = ctx_r32.$implicit; const i_r7 = ctx_r32.index; const ctx_r31 = ɵngcc0.ɵɵnextContext(2); return ctx_r31.save(box_r6, i_r7); });
    ɵngcc0.ɵɵtext(2, "Save");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 26);
    ɵngcc0.ɵɵlistener("click", function CheckboxFormGroupComponent_div_0_div_2_div_9_Template_div_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r33); const box_r6 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r34 = ɵngcc0.ɵɵnextContext(2); return ctx_r34.delete(box_r6); });
    ɵngcc0.ɵɵtext(4, "Delete");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 24);
    ɵngcc0.ɵɵlistener("click", function CheckboxFormGroupComponent_div_0_div_2_div_9_Template_div_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r33); const box_r6 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r36 = ɵngcc0.ɵɵnextContext(2); return ctx_r36.toggleEdit("close", box_r6); });
    ɵngcc0.ɵɵtext(6, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function CheckboxFormGroupComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelement(1, "input", 7);
    ɵngcc0.ɵɵelementStart(2, "label", 8);
    ɵngcc0.ɵɵtemplate(3, CheckboxFormGroupComponent_div_0_div_2_fa_icon_3_Template, 1, 3, "fa-icon", 9);
    ɵngcc0.ɵɵtemplate(4, CheckboxFormGroupComponent_div_0_div_2_fa_icon_4_Template, 1, 3, "fa-icon", 10);
    ɵngcc0.ɵɵtemplate(5, CheckboxFormGroupComponent_div_0_div_2_div_5_Template, 3, 2, "div", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, CheckboxFormGroupComponent_div_0_div_2_div_6_Template, 2, 1, "div", 12);
    ɵngcc0.ɵɵelementStart(7, "div", 13);
    ɵngcc0.ɵɵtemplate(8, CheckboxFormGroupComponent_div_0_div_2_div_8_Template, 2, 0, "div", 14);
    ɵngcc0.ɵɵtemplate(9, CheckboxFormGroupComponent_div_0_div_2_div_9_Template, 7, 0, "div", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const box_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("formArrayName", ctx_r2.arrayName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "", ctx_r2.ranId, "", i_r7, "");
    ɵngcc0.ɵɵproperty("formControlName", i_r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("for", "", ctx_r2.ranId, "", i_r7, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.hideIcons);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.hideIcons);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !box_r6.isEdit);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", box_r6.isEdit);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !box_r6.isEdit);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", box_r6.isEdit);
} }
const _c12 = function (a0) { return { "hide-icons": a0 }; };
function CheckboxFormGroupComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, CheckboxFormGroupComponent_div_0_div_1_Template, 2, 1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, CheckboxFormGroupComponent_div_0_div_2_Template, 10, 12, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("checkbox-form-group ", ctx_r0.className, "");
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.inputFormGroup)("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c12, ctx_r0.hideIcons));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.header);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.checkboxData);
} }
function CheckboxGroupComponent_div_0_div_1_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 10);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(2, _c10))("fixedWidth", true);
} }
function CheckboxGroupComponent_div_0_div_1_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 11);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(2, _c11))("fixedWidth", true);
} }
function CheckboxGroupComponent_div_0_div_1_fa_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 12);
} if (rf & 2) {
    const order_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction1(2, _c8, order_r2.icon))("fixedWidth", true);
} }
function CheckboxGroupComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelement(1, "input", 4);
    ɵngcc0.ɵɵelementStart(2, "label", 5);
    ɵngcc0.ɵɵtemplate(3, CheckboxGroupComponent_div_0_div_1_fa_icon_3_Template, 1, 3, "fa-icon", 6);
    ɵngcc0.ɵɵtemplate(4, CheckboxGroupComponent_div_0_div_1_fa_icon_4_Template, 1, 3, "fa-icon", 7);
    ɵngcc0.ɵɵtemplate(5, CheckboxGroupComponent_div_0_div_1_fa_icon_5_Template, 1, 4, "fa-icon", 8);
    ɵngcc0.ɵɵelementStart(6, "span", 9);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const order_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("formArrayName", ctx_r1.arrayName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "", ctx_r1.ranId, "", i_r3, "");
    ɵngcc0.ɵɵproperty("formControlName", i_r3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("for", "", ctx_r1.ranId, "", i_r3, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.hideIcons);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.hideIcons);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", order_r2.icon && !ctx_r1.hideIcons);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.checkboxData[i_r3].name);
} }
function CheckboxGroupComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, CheckboxGroupComponent_div_0_div_1_Template, 8, 10, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("checkbox-group ", ctx_r0.className, "");
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.inputFormGroup)("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c12, ctx_r0.hideIcons));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.checkboxData);
} }
function FileUploaderGroupComponent_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r2 = ɵngcc0.ɵɵnextContext().index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" #", i_r2, "");
} }
function FileUploaderGroupComponent_div_0_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} }
function FileUploaderGroupComponent_div_0_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(_r6.files[0].name);
} }
const _c13 = function () { return ["fas", "trash-alt"]; };
function FileUploaderGroupComponent_div_0_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵlistener("click", function FileUploaderGroupComponent_div_0_div_12_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); const i_r2 = ctx_r10.index; const n_r1 = ctx_r10.$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.removeUploader(i_r2, n_r1); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 10);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3, "Remove");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c13));
} }
function FileUploaderGroupComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "label", 1);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, FileUploaderGroupComponent_div_0_span_4_Template, 2, 1, "span", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵelementStart(6, "div", 4);
    ɵngcc0.ɵɵelementStart(7, "label", 5);
    ɵngcc0.ɵɵtemplate(8, FileUploaderGroupComponent_div_0_span_8_Template, 1, 0, "span", 2);
    ɵngcc0.ɵɵtemplate(9, FileUploaderGroupComponent_div_0_span_9_Template, 2, 1, "span", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "input", 6, 7);
    ɵngcc0.ɵɵlistener("change", function FileUploaderGroupComponent_div_0_Template_input_change_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const _r6 = ɵngcc0.ɵɵreference(11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onSelectFile($event, _r6.files[0]); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, FileUploaderGroupComponent_div_0_div_12_Template, 4, 2, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r2 = ctx.index;
    const _r6 = ɵngcc0.ɵɵreference(11);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("file-uploader-row ", ctx_r0.className, "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.labelPrefix);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.labelShowNumber);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("for", "asset" + i_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !_r6.files[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", _r6.files[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("id", "asset" + i_r2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.hideRemoveButtons);
} }
const _c14 = function (a0, a1) { return [a0, a1]; };
function InfoBoxAccordionComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelement(1, "fa-icon", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const box_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction2(1, _c14, box_r1.iconPrefix, box_r1.icon));
} }
function InfoBoxAccordionComponent_div_1_fa_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 11);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c6));
} }
function InfoBoxAccordionComponent_div_1_fa_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 11);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c7));
} }
function InfoBoxAccordionComponent_div_1_a_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("href", link_r8.href, ɵngcc0.ɵɵsanitizeUrl)("target", link_r8.target)("ngClass", link_r8.className);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(link_r8.title);
} }
function InfoBoxAccordionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("click", function InfoBoxAccordionComponent_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const box_r1 = ctx.$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.toggleInfoBox(box_r1); });
    ɵngcc0.ɵɵtemplate(1, InfoBoxAccordionComponent_div_1_div_1_Template, 2, 4, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵtemplate(5, InfoBoxAccordionComponent_div_1_fa_icon_5_Template, 1, 2, "fa-icon", 6);
    ɵngcc0.ɵɵtemplate(6, InfoBoxAccordionComponent_div_1_fa_icon_6_Template, 1, 2, "fa-icon", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "div", 7);
    ɵngcc0.ɵɵelementStart(8, "div", 8);
    ɵngcc0.ɵɵtemplate(9, InfoBoxAccordionComponent_div_1_a_9_Template, 2, 4, "a", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const box_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c3, box_r1.isActive))("ngStyle", ɵngcc0.ɵɵpureFunction1(10, _c4, ctx_r0.lineColor));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", box_r1.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(box_r1.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !box_r1.isActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", box_r1.isActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", box_r1.subTitle, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", box_r1.links);
} }
function ImageGridComponent_a_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r1.title);
} }
const _c15 = function (a0) { return { "background-image": a0 }; };
function ImageGridComponent_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 1);
    ɵngcc0.ɵɵtemplate(1, ImageGridComponent_a_1_div_1_Template, 3, 1, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("routerLink", item_r1.href)("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c15, ctx_r0.isMobile ? "url(" + item_r1.image + ")" : "url(" + item_r1.image2x + ")"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showTitles);
} }
function HorizCardComponent_div_0_div_1_h6_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h6", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const card_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(card_r2.subTitle);
} }
function HorizCardComponent_div_0_div_1_a_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const card_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassMap(card_r2.cta.className);
    ɵngcc0.ɵɵproperty("href", card_r2.cta.href, ɵngcc0.ɵɵsanitizeUrl)("target", card_r2.cta.target);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(card_r2.cta.title);
} }
function HorizCardComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "picture");
    ɵngcc0.ɵɵelement(3, "source", 3);
    ɵngcc0.ɵɵelement(4, "source", 4);
    ɵngcc0.ɵɵelement(5, "img", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵtemplate(7, HorizCardComponent_div_0_div_1_h6_7_Template, 2, 1, "h6", 7);
    ɵngcc0.ɵɵelementStart(8, "h3", 8);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(10, "div", 9);
    ɵngcc0.ɵɵtemplate(11, HorizCardComponent_div_0_div_1_a_11_Template, 2, 6, "a", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const card_r2 = ctx.$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("card horiz-card ", card_r2.className, "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("srcset", card_r2.image.url2x, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("srcset", card_r2.image.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", card_r2.image.url, ɵngcc0.ɵɵsanitizeUrl)("alt", card_r2.image.alt);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", card_r2.subTitle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(card_r2.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", card_r2.body, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", card_r2.cta);
} }
function HorizCardComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HorizCardComponent_div_0_div_1_Template, 12, 11, "div", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("horiz-cards ", ctx_r0.className, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.cards);
} }
function JumbotronComponent_h1_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "h1", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.options.title, ɵngcc0.ɵɵsanitizeHtml);
} }
function JumbotronComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 4);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.options.title, ɵngcc0.ɵɵsanitizeHtml);
} }
function ListButtonGroupComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.text);
} }
function ListButtonGroupComponent_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 11);
} }
function ListButtonGroupComponent_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 12);
} if (rf & 2) {
    const btn_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", btn_r2.status, ɵngcc0.ɵɵsanitizeHtml);
} }
function ListButtonGroupComponent_div_2_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 13);
} if (rf & 2) {
    const btn_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", btn_r2.body, ɵngcc0.ɵɵsanitizeHtml);
} }
function ListButtonGroupComponent_div_2_a_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 14);
    ɵngcc0.ɵɵelement(1, "fa-icon", 15);
    ɵngcc0.ɵɵelementStart(2, "span", 16);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sub_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    ɵngcc0.ɵɵclassMapInterpolate1("btn-primary pill align-items-center mobile-hover-flex clickable btn-sub-", i_r10, "");
    ɵngcc0.ɵɵpropertyInterpolate("fragment", sub_r9.fragment);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(7, _c9, sub_r9.href));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction2(9, _c14, sub_r9.iconPrefix, sub_r9.icon));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(sub_r9.title);
} }
const _c16 = function (a0) { return { "is-hover": a0 }; };
function ListButtonGroupComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵlistener("mouseover", function ListButtonGroupComponent_div_2_Template_div_mouseover_0_listener() { const btn_r2 = ctx.$implicit; return btn_r2.isHover = true; })("mouseout", function ListButtonGroupComponent_div_2_Template_div_mouseout_0_listener() { const btn_r2 = ctx.$implicit; return btn_r2.isHover = false; });
    ɵngcc0.ɵɵtemplate(1, ListButtonGroupComponent_div_2_span_1_Template, 1, 0, "span", 5);
    ɵngcc0.ɵɵtemplate(2, ListButtonGroupComponent_div_2_span_2_Template, 1, 1, "span", 6);
    ɵngcc0.ɵɵelementStart(3, "a", 7);
    ɵngcc0.ɵɵelement(4, "span", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, ListButtonGroupComponent_div_2_span_5_Template, 1, 1, "span", 9);
    ɵngcc0.ɵɵtemplate(6, ListButtonGroupComponent_div_2_a_6_Template, 4, 12, "a", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("d-flex list-button ", btn_r2.className, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c16, btn_r2.isHover));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isShowStatusDot);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isShowStatusText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("fragment", btn_r2.buttons[0].fragment);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(13, _c9, btn_r2.buttons[0].href));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", btn_r2.title, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", btn_r2.body);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", btn_r2.buttons);
} }
const _c17 = function (a0) { return { "is-mobile": a0 }; };
function LoadingStatusComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.text);
} }
function LoadingStatusComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelement(2, "div");
    ɵngcc0.ɵɵelement(3, "div");
    ɵngcc0.ɵɵelement(4, "div");
    ɵngcc0.ɵɵelement(5, "div");
    ɵngcc0.ɵɵelement(6, "div");
    ɵngcc0.ɵɵelement(7, "div");
    ɵngcc0.ɵɵelement(8, "div");
    ɵngcc0.ɵɵelement(9, "div");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function LoadingStatusComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, LoadingStatusComponent_div_0_div_1_Template, 2, 1, "div", 1);
    ɵngcc0.ɵɵtemplate(2, LoadingStatusComponent_div_0_div_2_Template, 10, 0, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("loading-status ", ctx_r0.className, " text-center");
    ɵngcc0.ɵɵstyleProp("color", ctx_r0.textColor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.text);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.icon);
} }
function NavbarComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.text);
} }
function NavbarComponent_img_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 11);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r1.imgSrc, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵpropertyInterpolate("alt", ctx_r1.imgAlt);
} }
function NavbarComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelement(1, "ascedia-loading-status", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("loading", true)("icon", true);
} }
const _c18 = function (a0) { return { "mr-2": a0 }; };
function NavbarComponent_ul_10_li_1_a_1_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 22);
} if (rf & 2) {
    const item_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction2(3, _c14, item_r5.iconPrefix, item_r5.icon))("fixedWidth", true)("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c18, item_r5.title));
} }
function NavbarComponent_ul_10_li_1_a_1_div_4_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 25);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c1));
} }
function NavbarComponent_ul_10_li_1_a_1_div_4_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 25);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c2));
} }
function NavbarComponent_ul_10_li_1_a_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵtemplate(1, NavbarComponent_ul_10_li_1_a_1_div_4_fa_icon_1_Template, 1, 2, "fa-icon", 24);
    ɵngcc0.ɵɵtemplate(2, NavbarComponent_ul_10_li_1_a_1_div_4_fa_icon_2_Template, 1, 2, "fa-icon", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r5.isVisible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r5.isVisible);
} }
function NavbarComponent_ul_10_li_1_a_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r5.badge);
} }
function NavbarComponent_ul_10_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 18);
    ɵngcc0.ɵɵlistener("click", function NavbarComponent_ul_10_li_1_a_1_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); const item_r5 = ctx_r18.$implicit; const i_r6 = ctx_r18.index; const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.navItemClick($event, item_r5, i_r6); });
    ɵngcc0.ɵɵtemplate(1, NavbarComponent_ul_10_li_1_a_1_fa_icon_1_Template, 1, 8, "fa-icon", 19);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, NavbarComponent_ul_10_li_1_a_1_div_4_Template, 3, 2, "div", 20);
    ɵngcc0.ɵɵtemplate(5, NavbarComponent_ul_10_li_1_a_1_div_5_Template, 3, 1, "div", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("wmRedirect", item_r5.children ? "#" : item_r5.href);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r5.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r5.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r5.children && ctx_r7.showArrows);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r5.badge);
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 32);
} if (rf & 2) {
    const child_r22 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction2(2, _c14, child_r22.iconPrefix, child_r22.icon))("fixedWidth", true);
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_div_5_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 25);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c1));
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_div_5_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 25);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c2));
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵtemplate(1, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_div_5_fa_icon_1_Template, 1, 2, "fa-icon", 24);
    ɵngcc0.ɵɵtemplate(2, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_div_5_fa_icon_2_Template, 1, 2, "fa-icon", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r22 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !child_r22.isVisible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", child_r22.isVisible);
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r22 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(child_r22.badge);
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_div_4_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 25);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c1));
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_div_4_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 25);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c2));
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵtemplate(1, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_div_4_fa_icon_1_Template, 1, 2, "fa-icon", 24);
    ɵngcc0.ɵɵtemplate(2, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_div_4_fa_icon_2_Template, 1, 2, "fa-icon", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const grandchild_r35 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !grandchild_r35.isVisible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", grandchild_r35.isVisible);
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const grandchild_r35 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(grandchild_r35.badge);
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_ul_6_li_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const greatgrandchild_r45 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(greatgrandchild_r45.badge);
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_ul_6_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r50 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 35);
    ɵngcc0.ɵɵlistener("click", function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_ul_6_li_1_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const greatgrandchild_r45 = ctx.$implicit; const m_r46 = ctx.index; const ctx_r49 = ɵngcc0.ɵɵnextContext(9); return ctx_r49.navItemClick($event, greatgrandchild_r45, m_r46); });
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_ul_6_li_1_div_4_Template, 3, 1, "div", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const greatgrandchild_r45 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("wmRedirect", greatgrandchild_r45.children ? null : greatgrandchild_r45.href);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(greatgrandchild_r45.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", greatgrandchild_r45.badge);
} }
const _c19 = function (a0) { return { "show": a0 }; };
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_ul_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 33);
    ɵngcc0.ɵɵtemplate(1, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_ul_6_li_1_Template, 5, 3, "li", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const grandchild_r35 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c19, grandchild_r35.isVisible));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", grandchild_r35.children);
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r53 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 34);
    ɵngcc0.ɵɵlistener("click", function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r53); const grandchild_r35 = ctx.$implicit; const k_r36 = ctx.index; const ctx_r52 = ɵngcc0.ɵɵnextContext(7); return ctx_r52.navItemClick($event, grandchild_r35, k_r36); });
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_div_4_Template, 3, 2, "div", 20);
    ɵngcc0.ɵɵtemplate(5, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_div_5_Template, 3, 1, "div", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_ul_6_Template, 2, 4, "ul", 31);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const grandchild_r35 = ctx.$implicit;
    const ctx_r34 = ɵngcc0.ɵɵnextContext(7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("wmRedirect", grandchild_r35.children ? null : grandchild_r35.href);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(grandchild_r35.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", grandchild_r35.children && ctx_r34.showArrows);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", grandchild_r35.badge);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", grandchild_r35.children);
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 33);
    ɵngcc0.ɵɵtemplate(1, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_li_1_Template, 7, 5, "li", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r22 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c19, child_r22.isVisible));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", child_r22.children);
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r57 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 29);
    ɵngcc0.ɵɵlistener("click", function NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r57); const ctx_r56 = ɵngcc0.ɵɵnextContext(); const child_r22 = ctx_r56.$implicit; const j_r23 = ctx_r56.index; const ctx_r55 = ɵngcc0.ɵɵnextContext(4); return ctx_r55.navItemClick($event, child_r22, j_r23); });
    ɵngcc0.ɵɵtemplate(2, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_fa_icon_2_Template, 1, 5, "fa-icon", 30);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_div_5_Template, 3, 2, "div", 20);
    ɵngcc0.ɵɵtemplate(6, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_div_6_Template, 3, 1, "div", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_ul_7_Template, 2, 4, "ul", 31);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r22 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r24 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("wmRedirect", child_r22.children ? null : child_r22.href);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", child_r22.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(child_r22.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", child_r22.children && ctx_r24.showArrows);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", child_r22.badge);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", child_r22.children);
} }
function NavbarComponent_ul_10_li_1_ul_2_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtemplate(1, NavbarComponent_ul_10_li_1_ul_2_li_1_ng_container_1_Template, 8, 6, "ng-container", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r22 = ctx.$implicit;
    const ctx_r21 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !child_r22.roles && !child_r22.subroles || child_r22.roles && !child_r22.subroles && (!ctx_r21.userRole || ctx_r21.userRole && child_r22.roles.includes(ctx_r21.userRole)) || !child_r22.roles && child_r22.subroles && (!ctx_r21.userSubRole || ctx_r21.userSubRole && child_r22.subroles.includes(ctx_r21.userSubRole)) || child_r22.roles && child_r22.subroles && (!ctx_r21.userRole || ctx_r21.userRole && child_r22.roles.includes(ctx_r21.userRole)) && (!ctx_r21.userSubRole || ctx_r21.userSubRole && child_r22.subroles.includes(ctx_r21.userSubRole)));
} }
function NavbarComponent_ul_10_li_1_ul_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 27);
    ɵngcc0.ɵɵtemplate(1, NavbarComponent_ul_10_li_1_ul_2_li_1_Template, 2, 1, "li", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c19, item_r5.isVisible));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", item_r5.children);
} }
const _c20 = function (a0) { return { "dropdown": a0 }; };
function NavbarComponent_ul_10_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 0);
    ɵngcc0.ɵɵtemplate(1, NavbarComponent_ul_10_li_1_a_1_Template, 6, 5, "a", 16);
    ɵngcc0.ɵɵtemplate(2, NavbarComponent_ul_10_li_1_ul_2_Template, 2, 4, "ul", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate1("nav-item ", item_r5.className, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c20, item_r5.children));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r5.roles && !item_r5.subroles || item_r5.roles && !item_r5.subroles && (!ctx_r4.userRole || ctx_r4.userRole && item_r5.roles.includes(ctx_r4.userRole)) || !item_r5.roles && item_r5.subroles && (!ctx_r4.userSubRole || ctx_r4.userSubRole && item_r5.subroles.includes(ctx_r4.userSubRole)) || item_r5.roles && item_r5.subroles && (!ctx_r4.userRole || ctx_r4.userRole && item_r5.roles.includes(ctx_r4.userRole)) && (!ctx_r4.userSubRole || ctx_r4.userSubRole && item_r5.subroles.includes(ctx_r4.userSubRole)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r5.children && (!item_r5.roles || item_r5.roles.includes(ctx_r4.userRole)));
} }
function NavbarComponent_ul_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 14);
    ɵngcc0.ɵɵtemplate(1, NavbarComponent_ul_10_li_1_Template, 3, 8, "li", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.navItems);
} }
function PaginationComponent_ul_0_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 6);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction1(2, _c8, ctx_r1.iconPrev))("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c18, ctx_r1.textPrev));
} }
function PaginationComponent_ul_0_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.textPrev);
} }
const _c21 = function (a0) { return { page: a0 }; };
function PaginationComponent_ul_0_li_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 1);
    ɵngcc0.ɵɵelementStart(1, "a", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r7 = ctx.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c3, i_r7 == ctx_r3.pageCurrent - 1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(6, _c9, ctx_r3.linkBase))("queryParams", ɵngcc0.ɵɵpureFunction1(8, _c21, i_r7 + 1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(i_r7 + 1);
} }
function PaginationComponent_ul_0_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.textNext);
} }
const _c22 = function (a0) { return { "ml-2": a0 }; };
function PaginationComponent_ul_0_fa_icon_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 6);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction1(2, _c8, ctx_r5.iconNext))("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c22, ctx_r5.textNext));
} }
const _c23 = function (a0) { return { "disabled": a0 }; };
function PaginationComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul");
    ɵngcc0.ɵɵelementStart(1, "li", 1);
    ɵngcc0.ɵɵelementStart(2, "a", 2);
    ɵngcc0.ɵɵtemplate(3, PaginationComponent_ul_0_fa_icon_3_Template, 1, 6, "fa-icon", 3);
    ɵngcc0.ɵɵtemplate(4, PaginationComponent_ul_0_span_4_Template, 2, 1, "span", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, PaginationComponent_ul_0_li_5_Template, 3, 10, "li", 5);
    ɵngcc0.ɵɵelementStart(6, "li", 1);
    ɵngcc0.ɵɵelementStart(7, "a", 2);
    ɵngcc0.ɵɵtemplate(8, PaginationComponent_ul_0_span_8_Template, 2, 1, "span", 4);
    ɵngcc0.ɵɵtemplate(9, PaginationComponent_ul_0_fa_icon_9_Template, 1, 6, "fa-icon", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("pagination my-4 ", ctx_r0.className, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(14, _c23, ctx_r0.pageCurrent == 1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(16, _c9, ctx_r0.linkBase))("queryParams", ɵngcc0.ɵɵpureFunction1(18, _c21, ctx_r0.pagePrev));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.iconPrev);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.textPrev);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.buttonArr);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(20, _c23, ctx_r0.pageCurrent == ctx_r0.buttonMax));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(22, _c9, ctx_r0.linkBase))("queryParams", ɵngcc0.ɵɵpureFunction1(24, _c21, ctx_r0.pageNext));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.textNext);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.iconNext);
} }
function SwiperBackgroundImageComponent_3_ng_template_0_a_3_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 13);
} if (rf & 2) {
    const slide_r1 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", slide_r1.subTitle, ɵngcc0.ɵɵsanitizeHtml);
} }
function SwiperBackgroundImageComponent_3_ng_template_0_a_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 10);
    ɵngcc0.ɵɵelement(1, "h5", 11);
    ɵngcc0.ɵɵtemplate(2, SwiperBackgroundImageComponent_3_ng_template_0_a_3_div_2_Template, 1, 1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const slide_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("wmRedirect", slide_r1.href)("target", slide_r1.target);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", slide_r1.title, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", slide_r1.subTitle);
} }
function SwiperBackgroundImageComponent_3_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "a", 7);
    ɵngcc0.ɵɵelement(2, "img", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, SwiperBackgroundImageComponent_3_ng_template_0_a_3_Template, 3, 4, "a", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const slide_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("wmRedirect", slide_r1.href)("target", slide_r1.target);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", slide_r1.image, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵpropertyInterpolate2("srcset", "", slide_r1.image, " 300w, ", slide_r1.image2x, " 992w", ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", slide_r1.title || slide_r1.subTitle);
} }
function SwiperBackgroundImageComponent_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SwiperBackgroundImageComponent_3_ng_template_0_Template, 4, 6, "ng-template", 5);
} }
const _c24 = function (a0, a1) { return { prevEl: a0, nextEl: a1 }; };
const _c25 = function () { return ["fas", "chevron-left"]; };
const _c26 = function () { return ["fas", "chevron-right"]; };
function SwiperCardImageComponent_h2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.text);
} }
function SwiperCardImageComponent_3_ng_template_0_h5_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "h5", 16);
} if (rf & 2) {
    const slide_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", slide_r2.title, ɵngcc0.ɵɵsanitizeHtml);
} }
function SwiperCardImageComponent_3_ng_template_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 17);
} if (rf & 2) {
    const slide_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", slide_r2.subTitle, ɵngcc0.ɵɵsanitizeHtml);
} }
function SwiperCardImageComponent_3_ng_template_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 18);
} if (rf & 2) {
    const slide_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", slide_r2.tertiary, ɵngcc0.ɵɵsanitizeHtml);
} }
function SwiperCardImageComponent_3_ng_template_0_a_7_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 4);
} if (rf & 2) {
    const slide_r2 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("mr-1 ", slide_r2.cta.iconClassName, "");
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction2(4, _c14, slide_r2.cta.iconPrefix ? slide_r2.cta.iconPrefix : "fas", slide_r2.cta.icon));
} }
function SwiperCardImageComponent_3_ng_template_0_a_7_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const slide_r2 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(slide_r2.cta.title);
} }
function SwiperCardImageComponent_3_ng_template_0_a_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 19);
    ɵngcc0.ɵɵtemplate(1, SwiperCardImageComponent_3_ng_template_0_a_7_fa_icon_1_Template, 1, 7, "fa-icon", 20);
    ɵngcc0.ɵɵtemplate(2, SwiperCardImageComponent_3_ng_template_0_a_7_span_2_Template, 2, 1, "span", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const slide_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1(" ", slide_r2.cta.className, "");
    ɵngcc0.ɵɵproperty("wmRedirect", slide_r2.cta.href);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", slide_r2.cta.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", slide_r2.cta.title);
} }
const _c27 = function () { return ["fas", "heart"]; };
function SwiperCardImageComponent_3_ng_template_0_div_8_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 27);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c27));
} }
const _c28 = function () { return ["fal", "heart"]; };
function SwiperCardImageComponent_3_ng_template_0_div_8_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 28);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c28));
} }
function SwiperCardImageComponent_3_ng_template_0_div_8_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 29);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(1, _c27));
} }
function SwiperCardImageComponent_3_ng_template_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵlistener("click", function SwiperCardImageComponent_3_ng_template_0_div_8_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const slide_r2 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.onToggleFavorite(slide_r2); });
    ɵngcc0.ɵɵtemplate(1, SwiperCardImageComponent_3_ng_template_0_div_8_fa_icon_1_Template, 1, 2, "fa-icon", 23);
    ɵngcc0.ɵɵelementStart(2, "div", 24);
    ɵngcc0.ɵɵtemplate(3, SwiperCardImageComponent_3_ng_template_0_div_8_fa_icon_3_Template, 1, 2, "fa-icon", 25);
    ɵngcc0.ɵɵtemplate(4, SwiperCardImageComponent_3_ng_template_0_div_8_fa_icon_4_Template, 1, 2, "fa-icon", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const slide_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", slide_r2.isFavorite);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !slide_r2.isFavorite);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !slide_r2.isFavorite);
} }
function SwiperCardImageComponent_3_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "a", 8);
    ɵngcc0.ɵɵelement(2, "img", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "a", 10);
    ɵngcc0.ɵɵtemplate(4, SwiperCardImageComponent_3_ng_template_0_h5_4_Template, 1, 1, "h5", 11);
    ɵngcc0.ɵɵtemplate(5, SwiperCardImageComponent_3_ng_template_0_div_5_Template, 1, 1, "div", 12);
    ɵngcc0.ɵɵtemplate(6, SwiperCardImageComponent_3_ng_template_0_div_6_Template, 1, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, SwiperCardImageComponent_3_ng_template_0_a_7_Template, 3, 6, "a", 14);
    ɵngcc0.ɵɵtemplate(8, SwiperCardImageComponent_3_ng_template_0_div_8_Template, 5, 3, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const slide_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", slide_r2.href);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", slide_r2.image, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵpropertyInterpolate2("srcset", "", slide_r2.image, " 300w, ", slide_r2.image2x, " 992w", ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", slide_r2.href);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", slide_r2.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", slide_r2.subTitle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", slide_r2.tertiary);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", slide_r2.cta);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.hasFavorites);
} }
function SwiperCardImageComponent_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SwiperCardImageComponent_3_ng_template_0_Template, 9, 10, "ng-template", 6);
} }
const _c29 = function () { return { "checkInView": true }; };
function SwiperJumbotronComponent_2_ng_template_0_a_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const slide_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("href", slide_r1.cta.href, ɵngcc0.ɵɵsanitizeUrl)("target", slide_r1.cta.target);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(slide_r1.cta.text);
} }
function SwiperJumbotronComponent_2_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, SwiperJumbotronComponent_2_ng_template_0_a_4_Template, 2, 3, "a", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const slide_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c15, ctx_r3.isMobile ? "url(" + slide_r1.image.url + ")" : "url(" + slide_r1.image.url2x + ")"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(slide_r1.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", slide_r1.cta);
} }
function SwiperJumbotronComponent_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SwiperJumbotronComponent_2_ng_template_0_Template, 5, 5, "ng-template", 4);
} }
function TabGroupControllerComponent_li_1_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 5);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction2(1, _c14, ctx_r2.iconPrefix, ctx_r2.icon));
} }
function TabGroupControllerComponent_li_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.text);
} }
function TabGroupControllerComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵtemplate(1, TabGroupControllerComponent_li_1_fa_icon_1_Template, 1, 4, "fa-icon", 3);
    ɵngcc0.ɵɵtemplate(2, TabGroupControllerComponent_li_1_span_2_Template, 2, 1, "span", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.text);
} }
function TabGroupControllerComponent_ng_container_2_li_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵelement(1, "fa-icon", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r4 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction2(1, _c14, tab_r4.iconPrefix, tab_r4.icon));
} }
function TabGroupControllerComponent_ng_container_2_li_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵelement(1, "fa-icon", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r4 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction2(1, _c14, tab_r4.iconPrefixActive, tab_r4.iconActive));
} }
const _c30 = function (a0, a1) { return { "active": a0, "disabled": a1 }; };
function TabGroupControllerComponent_ng_container_2_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 8);
    ɵngcc0.ɵɵlistener("click", function TabGroupControllerComponent_ng_container_2_li_1_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const tab_r4 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.tabClick(tab_r4.id); });
    ɵngcc0.ɵɵtemplate(1, TabGroupControllerComponent_ng_container_2_li_1_span_1_Template, 2, 4, "span", 9);
    ɵngcc0.ɵɵtemplate(2, TabGroupControllerComponent_ng_container_2_li_1_span_2_Template, 2, 4, "span", 9);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c30, !ctx_r5.parentId && tab_r4.id == ctx_r5.sectionActive || ctx_r5.parentId && tab_r4.id == ctx_r5.sectionActiveSub, tab_r4.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", tab_r4.icon && !tab_r4.iconActive || tab_r4.icon && tab_r4.iconActive && (!ctx_r5.parentId && tab_r4.id != ctx_r5.sectionActive || ctx_r5.parentId && tab_r4.id != ctx_r5.sectionActiveSub));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", tab_r4.iconActive && (!ctx_r5.parentId && tab_r4.id == ctx_r5.sectionActive || ctx_r5.parentId && tab_r4.id == ctx_r5.sectionActiveSub));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(tab_r4.title);
} }
function TabGroupControllerComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TabGroupControllerComponent_ng_container_2_li_1_Template, 5, 7, "li", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r4 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !tab_r4.roles && !tab_r4.subroles || tab_r4.roles && tab_r4.roles.includes(ctx_r1.userRole) && !tab_r4.subroles || tab_r4.roles && tab_r4.roles.includes(ctx_r1.userRole) && tab_r4.subroles && (!ctx_r1.userSubRole || tab_r4.subroles.includes(ctx_r1.userSubRole)));
} }
class ButtonComponent {
    constructor() {
        this.text = '';
        this.disabled = false;
        this.btnClass = '';
        this.onClick = new EventEmitter();
    }
}
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(); };
ButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["ascedia-button"]], inputs: { text: "text", disabled: "disabled", btnClass: "btnClass" }, outputs: { onClick: "onClick" }, decls: 2, vars: 5, consts: [[3, "disabled", "click"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function ButtonComponent_Template_button_click_0_listener($event) { return ctx.onClick.emit($event); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.btnClass);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.text);
    } }, encapsulation: 2 });
ButtonComponent.propDecorators = {
    text: [{ type: Input }],
    disabled: [{ type: Input }],
    btnClass: [{ type: Input }],
    onClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-button',
                template: `
    <button [disabled]="disabled" (click)="onClick.emit($event)" class="{{btnClass}}">{{text}}</button>
  `
            }]
    }], function () { return []; }, { text: [{
            type: Input
        }], disabled: [{
            type: Input
        }], btnClass: [{
            type: Input
        }], onClick: [{
            type: Output
        }] }); })();

class ListButtonComponent {
    //public breakpoint = Breakpoint;
    constructor() {
        this.text = '';
        this.status = '';
        this.className = '';
        this.isShowStatusText = false;
        this.isHover = false;
        //public isHover: boolean = false;
        this.isMobile = false;
        this.toResizeMs = 100;
        this.window = { width: 0, height: 0 };
        this.toResize = setTimeout(() => {
            this.getWindowDims();
        }, this.toResizeMs);
    }
    /**
     * Listen for window resize
     * @param event
     */
    onResize(event) {
        //console.log(event.target.innerWidth, 'x', event.target.innerHeight);
        clearTimeout(this.toResize);
        this.toResize = setTimeout(() => {
            this.getWindowDims(event);
        }, this.toResizeMs);
    }
    /**
     * Get window dimensions
     * @param event
     */
    getWindowDims(event = null) {
        if (event) {
            this.window.width = event.target.innerWidth;
            this.window.height = event.target.innerHeight;
        }
        else {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
        //console.log('window:', this.window);let wasMobile = this.isMobile;
        if (this.window.width < 768 /* md */) {
            this.isMobile = true;
        }
        else {
            this.isMobile = false;
        }
        //console.log('isMobile:', this.isMobile);
    }
}
ListButtonComponent.ɵfac = function ListButtonComponent_Factory(t) { return new (t || ListButtonComponent)(); };
ListButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ListButtonComponent, selectors: [["ascedia-list-button"]], hostBindings: function ListButtonComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function ListButtonComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { text: "text", status: "status", className: "className", isShowStatusText: "isShowStatusText", isHover: "isHover" }, decls: 6, vars: 6, consts: [["href", "#", 3, "mouseover", "mouseout"], [1, "status-dot", "mr-1"], ["class", "status-text mr-3", 4, "ngIf"], [1, "ml-1", "mr-3", "font-weight-bold"], ["class", "btn btn-primary pill d-flex align-items-center no-pointer-events", 4, "ngIf"], [1, "status-text", "mr-3"], [1, "btn", "btn-primary", "pill", "d-flex", "align-items-center", "no-pointer-events"], [3, "icon"], [1, "ml-2"]], template: function ListButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵlistener("mouseover", function ListButtonComponent_Template_a_mouseover_0_listener() { return ctx.isHover = true; })("mouseout", function ListButtonComponent_Template_a_mouseout_0_listener() { return ctx.isHover = false; });
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵtemplate(2, ListButtonComponent_span_2_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, ListButtonComponent_div_5_Template, 4, 2, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("d-flex align-items-center clickable list-button ", ctx.className, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isShowStatusText);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.text);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMobile || ctx.isHover);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.FaIconComponent], encapsulation: 2 });
ListButtonComponent.ctorParameters = () => [];
ListButtonComponent.propDecorators = {
    text: [{ type: Input }],
    status: [{ type: Input }],
    className: [{ type: Input }],
    isShowStatusText: [{ type: Input }],
    isHover: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListButtonComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-list-button',
                template: "\r\n<a href=\"#\" class=\"d-flex align-items-center clickable list-button {{className}}\" (mouseover)=\"isHover=true\" (mouseout)=\"isHover=false\">\r\n\t<span class=\"status-dot mr-1\"></span>\r\n\t<span class=\"status-text mr-3\" *ngIf=\"isShowStatusText\">{{status}}</span>\r\n\t<span class=\"ml-1 mr-3 font-weight-bold\">{{text}}</span>\r\n\t<div class=\"btn btn-primary pill d-flex align-items-center no-pointer-events\" *ngIf=\"isMobile || isHover\">\r\n\t\t<fa-icon [icon]=\"['fas', 'pen']\"></fa-icon>\r\n\t\t<span class=\"ml-2\">Edit</span>\r\n\t</div>\r\n\t<!-- <span class=\"ml-auto text-small\">isHover:{{isHover}}</span> -->\r\n</a>\r\n"
            }]
    }], function () { return []; }, { text: [{
            type: Input
        }], status: [{
            type: Input
        }], className: [{
            type: Input
        }], isShowStatusText: [{
            type: Input
        }], isHover: [{
            type: Input
        }], 
    /**
     * Listen for window resize
     * @param event
     */
    onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

class AccordionBasicComponent {
    constructor() {
        this.className = '';
        this.list = [];
        this.textColor = '';
        this.lineColor = '';
    }
    ngOnInit() {
        //console.log('AccordionBasicComponent.OnInit.tabList:', this.tabList);
    }
    /**
     * Toggle content open/closed, close others
     * @param box
     */
    toggleContent(tab) {
        if (!this.list)
            return;
        this.list.forEach(item => {
            //console.log('tab:', tab, 'vs', item);
            if (tab == item) {
                //console.log('found match ^^');
                //item.isActive = true;
                item.isActive = !item.isActive;
            }
            else {
                if (item.isActive)
                    item.isActive = false;
            }
        });
    }
}
AccordionBasicComponent.ɵfac = function AccordionBasicComponent_Factory(t) { return new (t || AccordionBasicComponent)(); };
AccordionBasicComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AccordionBasicComponent, selectors: [["ascedia-accordion-basic"]], inputs: { className: "className", list: "list", textColor: "textColor", lineColor: "lineColor" }, decls: 2, vars: 7, consts: [[3, "ngStyle"], ["class", "group", 4, "ngFor", "ngForOf"], [1, "group"], [3, "ngClass", "ngStyle", "click"], [1, "toggle", "ml-auto"], [3, "icon", 4, "ngIf"], [1, "body", 3, "ngClass", "ngStyle", "innerHTML"], [3, "icon"]], template: function AccordionBasicComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AccordionBasicComponent_div_1_Template, 8, 19, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("accordion-basic ", ctx.className, "");
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c5, ctx.textColor));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.list);
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgForOf, ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc2.FaIconComponent], encapsulation: 2 });
AccordionBasicComponent.propDecorators = {
    className: [{ type: Input }],
    list: [{ type: Input }],
    textColor: [{ type: Input }],
    lineColor: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionBasicComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-accordion-basic',
                template: "<div class=\"accordion-basic {{className}}\"\r\n\t[ngStyle]=\"{'color': textColor}\">\r\n\r\n\t<div *ngFor=\"let tab of list; let i = index;\"\r\n\t\tclass=\"group\">\r\n\t\t<div class=\"tab tab--{{i}}\" \r\n\t\t\t(click)=\"toggleContent(tab)\"\r\n\t\t\t[ngClass]=\"{'active': tab.isActive}\"\r\n\t\t\t[ngStyle]=\"{'border-color': textColor}\">\r\n\t\t\t<span>{{tab.title}}</span>\r\n\t\t\t<div class=\"toggle ml-auto\">\r\n\t\t\t\t<fa-icon [icon]=\"['fas', 'chevron-down']\" *ngIf=\"!tab.isActive\"></fa-icon>\r\n\t\t\t\t<fa-icon [icon]=\"['fas', 'chevron-up']\" *ngIf=\"tab.isActive\"></fa-icon>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t\r\n\t\t<div class=\"body\" \r\n\t\t\t[ngClass]=\"{'active': tab.isActive}\"\r\n\t\t\t[ngStyle]=\"{'border-color': lineColor + ' !important'}\"\r\n\t\t\t[innerHTML]=\"tab.body\"></div>\r\n\t\t\r\n\t</div>\r\n</div>"
            }]
    }], function () { return []; }, { className: [{
            type: Input
        }], list: [{
            type: Input
        }], textColor: [{
            type: Input
        }], lineColor: [{
            type: Input
        }] }); })();

class AccordionTabGroupComponent {
    constructor() {
        this.className = '';
        this.tabList = [];
        this.textColor = '';
        this.lineColor = '';
        this.wasMobile = null;
        this.isMobile = false;
        this.toResizeMs = 300;
        this.window = { width: 0, height: 0 };
    }
    //public breakpoint = Breakpoint;
    ngOnInit() {
        //console.log('AccordionTabGroupComponent.OnInit.tabList:', this.tabList);
    }
    /**
     * Listen for window resize
     * @param event
     */
    onResize(event) {
        //console.log(event.target.innerWidth, 'x', event.target.innerHeight);
        clearTimeout(this.toResize);
        this.toResize = setTimeout(() => {
            this.getWindowDims(event);
        }, this.toResizeMs);
    }
    /**
     * Get window dimensions
     * @param event
     */
    getWindowDims(event = null) {
        if (event) {
            this.window.width = event.target.innerWidth;
            this.window.height = event.target.innerHeight;
        }
        else {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
        //console.log('AccordionTabGroupComponent.window:', this.window);
        this.updateComponent();
    }
    updateComponent() {
        this.wasMobile = this.isMobile;
        if (this.window.width < 992 /* lg */) {
            this.isMobile = true;
        }
        else {
            this.isMobile = false;
        }
        //console.log('wasMobile:', this.wasMobile);
        //console.log('isMobile:', this.isMobile);
        if (this.wasMobile == true && this.isMobile == false) {
            //console.log('********** just switched to detop');
            if (this.tabList.length > 0) {
                this.toggleContent(this.tabList[0]);
            }
        }
        //console.log('AccordionTabGroupComponent.isMobile:', this.isMobile);
    }
    /**
     * Toggle content open/closed, close others
     * @param box
     */
    toggleContent(tab) {
        if (!this.tabList)
            return;
        this.tabList.forEach(item => {
            //console.log('tab:', tab, 'vs', item);
            if (tab == item) {
                //console.log('found match ^^');
                if (this.isMobile) {
                    item.isActive = !item.isActive;
                }
                else {
                    item.isActive = true;
                }
            }
            else {
                if (item.isActive)
                    item.isActive = false;
            }
        });
    }
}
AccordionTabGroupComponent.ɵfac = function AccordionTabGroupComponent_Factory(t) { return new (t || AccordionTabGroupComponent)(); };
AccordionTabGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AccordionTabGroupComponent, selectors: [["ascedia-accordion-tab-group"]], hostBindings: function AccordionTabGroupComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function AccordionTabGroupComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { className: "className", tabList: "tabList", textColor: "textColor", lineColor: "lineColor" }, decls: 2, vars: 7, consts: [[3, "ngStyle"], [4, "ngFor", "ngForOf"], [3, "ngClass", "ngStyle", "click"], [1, "toggle", "ml-auto"], [3, "icon", 4, "ngIf"], [1, "body", 3, "ngClass", "ngStyle", "innerHTML"], [3, "icon"]], template: function AccordionTabGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AccordionTabGroupComponent_ng_container_1_Template, 8, 19, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("accordion-tab-group ", ctx.className, "");
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c5, ctx.textColor));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tabList);
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgForOf, ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc2.FaIconComponent], encapsulation: 2 });
AccordionTabGroupComponent.propDecorators = {
    className: [{ type: Input }],
    tabList: [{ type: Input }],
    textColor: [{ type: Input }],
    lineColor: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionTabGroupComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-accordion-tab-group',
                template: "<div class=\"accordion-tab-group {{className}}\"\r\n\t[ngStyle]=\"{'color': textColor}\">\r\n\t<ng-container *ngFor=\"let tab of tabList; let i = index;\">\r\n\t\t<div class=\"tab tab--{{i}}\" \r\n\t\t\t(click)=\"toggleContent(tab)\"\r\n\t\t\t[ngClass]=\"{'active': tab.isActive}\"\r\n\t\t\t[ngStyle]=\"{'border-color': textColor}\">\r\n\t\t\t<span>{{tab.title}}</span>\r\n\t\t\t<div class=\"toggle ml-auto\">\r\n\t\t\t\t<fa-icon [icon]=\"['fal', 'plus']\" *ngIf=\"!tab.isActive\"></fa-icon>\r\n\t\t\t\t<fa-icon [icon]=\"['fal', 'minus']\" *ngIf=\"tab.isActive\"></fa-icon>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t\r\n\t\t<div class=\"body\" \r\n\t\t\t[ngClass]=\"{'active': tab.isActive}\"\r\n\t\t\t[ngStyle]=\"{'border-color': lineColor + ' !important'}\"\r\n\t\t\t[innerHTML]=\"tab.body\"></div>\r\n\t\t\r\n\t</ng-container>\r\n</div>"
            }]
    }], function () { return []; }, { className: [{
            type: Input
        }], tabList: [{
            type: Input
        }], textColor: [{
            type: Input
        }], lineColor: [{
            type: Input
        }], 
    /**
     * Listen for window resize
     * @param event
     */
    onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

class AlertBannerComponent {
    constructor() {
        this.options = {};
        this.consoleLogs = false;
    }
    ngOnInit() {
        if (this.consoleLogs)
            console.log('AlertBannerComponent.OnInit.options:', this.options);
    }
}
AlertBannerComponent.ɵfac = function AlertBannerComponent_Factory(t) { return new (t || AlertBannerComponent)(); };
AlertBannerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AlertBannerComponent, selectors: [["ascedia-alert-banner"]], inputs: { options: "options", consoleLogs: "consoleLogs" }, decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"], [1, "container", "d-md-flex", "align-items-center"], ["class", "alert-left d-md-flex", 4, "ngIf"], [1, "alert-body", 3, "innerHTML"], ["class", "alert-right d-md-flex", 4, "ngIf"], [1, "alert-left", "d-md-flex"], [4, "ngFor", "ngForOf"], [3, "href"], ["class", "mr-2", 3, "icon", 4, "ngIf"], [1, "mr-2", 3, "icon"], [1, "alert-right", "d-md-flex"]], template: function AlertBannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AlertBannerComponent_div_0_Template, 5, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.options.isActive);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc2.FaIconComponent], encapsulation: 2 });
AlertBannerComponent.propDecorators = {
    options: [{ type: Input }],
    consoleLogs: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertBannerComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-alert-banner',
                template: "<div class=\"alert-banner {{options.className}}\" *ngIf=\"options.isActive\">\r\n\t<div class=\"container d-md-flex align-items-center\">\r\n\r\n\t\t<ul class=\"alert-left d-md-flex\" *ngIf=\"options?.ulLeft\">\r\n\t\t\t<li *ngFor=\"let item of options.ulLeft\">\r\n\t\t\t\t<a href=\"{{item.href}}\">\r\n\t\t\t\t\t<fa-icon *ngIf=\"item.icon\" [icon]=\"['fas', item.icon]\" class=\"mr-2\"></fa-icon>\r\n\t\t\t\t\t<span>{{item.title}}</span>\r\n\t\t\t\t</a>\r\n\t\t\t</li>\r\n\t\t</ul>\r\n\r\n\t\t<div class=\"alert-body\" [innerHTML]=\"options.text\"></div>\r\n\r\n\t\t<ul class=\"alert-right d-md-flex\" *ngIf=\"options.ulRight\">\r\n\t\t\t<li *ngFor=\"let item of options.ulRight\">\r\n\t\t\t\t<a href=\"{{item.href}}\">\r\n\t\t\t\t\t<fa-icon *ngIf=\"item.icon\" [icon]=\"['fas', item.icon]\" class=\"mr-2\"></fa-icon>\r\n\t\t\t\t\t<span>{{item.title}}</span>\r\n\t\t\t\t</a>\r\n\t\t\t</li>\r\n\t\t</ul>\r\n\r\n\t</div>\r\n\t\r\n</div>\r\n"
            }]
    }], function () { return []; }, { options: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }] }); })();

class BreadcrumbsComponent {
    constructor() {
        this.breadcrumbs = [];
        this.className = '';
        this.consoleLogs = false;
    }
    ngOnInit() {
        if (this.consoleLogs)
            console.log('BreadcrumbsComponent.OnInit.breadcrumbs:', this.breadcrumbs);
    }
}
BreadcrumbsComponent.ɵfac = function BreadcrumbsComponent_Factory(t) { return new (t || BreadcrumbsComponent)(); };
BreadcrumbsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbsComponent, selectors: [["ascedia-breadcrumbs"]], inputs: { breadcrumbs: "breadcrumbs", className: "className", consoleLogs: "consoleLogs" }, decls: 3, vars: 4, consts: [["aria-label", "breadcrumb"], ["class", "breadcrumb-item", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "breadcrumb-item", 3, "ngClass"], [3, "routerLink", "innerHTML", 4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [3, "routerLink", "innerHTML"], [3, "innerHTML"]], template: function BreadcrumbsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "ul");
        ɵngcc0.ɵɵtemplate(2, BreadcrumbsComponent_li_2_Template, 3, 5, "li", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("breadcrumb ", ctx.className, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.breadcrumbs);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc3.RouterLinkWithHref], encapsulation: 2 });
BreadcrumbsComponent.propDecorators = {
    breadcrumbs: [{ type: Input }],
    className: [{ type: Input }],
    consoleLogs: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbsComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-breadcrumbs',
                template: "<nav aria-label=\"breadcrumb\">\r\n\t<ul class=\"breadcrumb {{className}}\">\r\n\t\t<li *ngFor=\"let crumb of breadcrumbs\"\r\n\t\t\tclass=\"breadcrumb-item\"\r\n\t\t\t[ngClass]=\"{'active': !crumb.href}\"\r\n\t\t\t>\r\n\t\t\t<a [routerLink]=\"[crumb.href]\" \r\n\t\t\t\t[innerHTML]=\"crumb.title\"\r\n\t\t\t\t*ngIf=\"crumb.href\"></a>\r\n\t\t\t<span [innerHTML]=\"crumb.title\"\r\n\t\t\t\t*ngIf=\"!crumb.href\"></span>\r\n\t\t</li>\r\n\t\t<!-- <li class=\"breadcrumb-item\"><a [routerLink]=\"['/destinations']\">Destinations</a></li>\r\n\t\t<li class=\"breadcrumb-item active\">{{product.name}}</li> -->\r\n\t</ul>\r\n</nav>"
            }]
    }], function () { return []; }, { breadcrumbs: [{
            type: Input
        }], className: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }] }); })();

class CheckboxFormGroupComponent {
    constructor() {
        //https://stackblitz.com/edit/forsoanswer-nestedformcontrol?file=app%2Fcomp3.component.ts
        this.checkboxData = [];
        this.checkboxActive = [];
        this.inputFormGroup = new FormGroup({});
        this.arrayName = "";
        this.className = "";
        this.consoleLogs = false;
        this.hideIcons = false;
        this.header = [];
        this.emitter = new EventEmitter();
        this.ranId = 'cbg' + Math.floor(Math.random() * 1000) + '_'; //need prefix so no identical ids if more than one CBG is on the stage
        this.counter = 1;
    }
    ngOnInit() {
        if (this.consoleLogs)
            console.group('CheckboxFormGroupComponent');
        if (this.consoleLogs)
            console.log('inputFormGroup:', this.inputFormGroup);
        if (this.consoleLogs)
            console.log('checkboxData:', this.checkboxData);
        if (this.consoleLogs)
            console.log('checkboxActive:', this.checkboxActive);
        if (this.consoleLogs)
            console.log('arrayName:', this.arrayName);
        if (this.consoleLogs)
            console.log('className:', this.className);
        if (this.consoleLogs)
            console.log('ranId:', this.ranId);
        this.addCheckboxes();
        if (this.consoleLogs)
            console.groupEnd();
    }
    ngOnDestroy() {
        this.inputFormGroup.get(this.arrayName).clear();
        if (this.consoleLogs)
            console.log('CheckboxFormGroupComponent.ngOnDestroy');
    }
    /**
     * Add checkboxes dynamically
     */
    addCheckboxes() {
        if (this.consoleLogs)
            console.log('addCheckboxes.checkboxData:', this.checkboxData);
        if (this.checkboxData) {
            //this.itemsData = [];
            this.checkboxData.forEach((box) => {
                //if(this.consoleLogs) console.log('box:', box);
                if (box.fields) {
                    box.fields.forEach(field => {
                        if (!field.type)
                            field.type = 'text';
                    });
                }
                const isActive = (this.checkboxActive.length > 0 && this.checkboxActive.indexOf(box.id) > -1) ? true : false;
                // if(this.consoleLogs) console.log('this.checkboxActive.length:', this.checkboxActive.length);
                // if(this.consoleLogs) console.log('this.checkboxActive.indexOf(box.id):', this.checkboxActive.indexOf(box.id));
                // if(this.consoleLogs) console.log('isActive:', isActive);
                //const isActive = false;
                this.inputFormGroup.get(this.arrayName).push(new FormControl(isActive));
                //if(this.consoleLogs) console.groupEnd();
            });
        }
    }
    /**
     * Add new checkbox
     */
    addNewCheckbox(newId, newFields) {
        if (this.consoleLogs)
            console.log('addNewCheckbox.checkboxData:', this.checkboxData);
        if (!this.checkboxData)
            this.checkboxData = [];
        const box = {
            id: newId,
            fields: newFields,
            isEdit: true
        };
        this.checkboxData.push(box);
        //(this.inputFormGroup.get(this.arrayName) as FormArray).push(new FormControl(true));
        //this.counter++;
    }
    /**
     * Update checkbox ID once it gets back from API
     * @param id
     */
    updateCheckbox(oldId, newId) {
        if (this.consoleLogs)
            console.log('updateCheckbox:', oldId, newId);
        this.checkboxData.find(item => {
            if (item.id == oldId) {
                //console.log('found box to update:', item);
                item.id = newId;
            }
        });
    }
    toggleEdit(action = null, box) {
        //console.log('toggleEdit', action);
        switch (action) {
            case 'open':
                box.isEdit = true;
                break;
            case 'close':
                box.isEdit = false;
                break;
            default:
                box.isEdit = !box.isEdit;
                break;
        }
    }
    save(box, i) {
        if (this.consoleLogs)
            console.log('save', box, i);
        const inputField1 = document.getElementById('field1_' + i).value, inputField2 = document.getElementById('field2_' + i).value;
        // console.log('inputfield1', inputfield1);
        // console.log('inputField2', inputField2);
        box.fields[0].value = inputField1;
        box.fields[1].value = inputField2;
        const obj = { action: 'save', box: box };
        this.notifyDataChange(obj);
        this.toggleEdit('close', box);
    }
    delete(box) {
        if (this.consoleLogs)
            console.log('delete', box);
        const obj = { action: 'delete', box: box };
        this.notifyDataChange(obj);
        this.toggleEdit('close', box);
    }
    /**
     * Notify parent component that data changed
     */
    notifyDataChange(obj) {
        if (this.consoleLogs)
            console.log('notifyDataChange()');
        this.emitter.emit(obj);
    }
}
CheckboxFormGroupComponent.ɵfac = function CheckboxFormGroupComponent_Factory(t) { return new (t || CheckboxFormGroupComponent)(); };
CheckboxFormGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CheckboxFormGroupComponent, selectors: [["ascedia-checkbox-form-group"]], inputs: { checkboxData: "checkboxData", checkboxActive: "checkboxActive", inputFormGroup: "inputFormGroup", arrayName: "arrayName", className: "className", consoleLogs: "consoleLogs", hideIcons: "hideIcons", header: "header" }, outputs: { emitter: "emitter" }, decls: 1, vars: 1, consts: [[3, "class", "formGroup", "ngClass", 4, "ngIf"], [3, "formGroup", "ngClass"], ["class", "form-group-header", 4, "ngIf"], ["class", "form-group", 3, "formArrayName", 4, "ngFor", "ngForOf"], [1, "form-group-header"], [3, "class", 4, "ngFor", "ngForOf"], [1, "form-group", 3, "formArrayName"], ["type", "checkbox", 3, "formControlName", "id"], [3, "for"], ["size", "lg", "class", "checked cb-check", 3, "icon", "fixedWidth", 4, "ngIf"], ["size", "lg", "class", "unchecked cb-check", 3, "icon", "fixedWidth", 4, "ngIf"], ["class", "d-flex", 4, "ngIf"], ["class", "cb-form d-flex", 4, "ngIf"], [1, "cb-btns", "ml-auto", "d-flex"], ["class", "cb-btn", 3, "click", 4, "ngIf"], ["size", "lg", 1, "checked", "cb-check", 3, "icon", "fixedWidth"], ["size", "lg", 1, "unchecked", "cb-check", 3, "icon", "fixedWidth"], [1, "d-flex"], [4, "ngFor", "ngForOf"], [1, "cb-text", "body", 3, "innerHTML"], [3, "class", 4, "ngIf"], [1, "cb-form", "d-flex"], [3, "for", 4, "ngIf"], [1, "form-control", "mr-2", 3, "type", "name", "id", "value"], [1, "cb-btn", 3, "click"], [1, "cb-btn", "text-success", 3, "click"], [1, "cb-btn", "text-danger", 3, "click"]], template: function CheckboxFormGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CheckboxFormGroupComponent_div_0_Template, 3, 9, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.checkboxData);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc4.FormArrayName, ɵngcc4.CheckboxControlValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc2.FaIconComponent], encapsulation: 2 });
CheckboxFormGroupComponent.ctorParameters = () => [];
CheckboxFormGroupComponent.propDecorators = {
    checkboxData: [{ type: Input }],
    checkboxActive: [{ type: Input }],
    inputFormGroup: [{ type: Input }],
    arrayName: [{ type: Input }],
    className: [{ type: Input }],
    consoleLogs: [{ type: Input }],
    hideIcons: [{ type: Input }],
    header: [{ type: Input }],
    emitter: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxFormGroupComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-checkbox-form-group',
                template: "<div class=\"checkbox-form-group {{className}}\" \n\t[formGroup]=\"inputFormGroup\" \n\t*ngIf=\"checkboxData\" \n\t[ngClass]=\"{'hide-icons': hideIcons}\">\n\t<div class=\"form-group-header\" *ngIf=\"header\">\n\t\t<span class=\"title{{i}}\" *ngFor=\"let title of header; let i = index;\">{{title}}</span>\n\t</div>\n\t<div class=\"form-group\" \n\t\tformArrayName=\"{{arrayName}}\"\n\t\t*ngFor=\"let box of checkboxData; let i = index;\">\n\t\t<input type=\"checkbox\" \n\t\t\t[formControlName]=\"i\" \n\t\t\tid=\"{{ranId}}{{i}}\"\n\t\t\t>\n\t\t<label for=\"{{ranId}}{{i}}\">\n\t\t\t<fa-icon [icon]=\"['fas', 'check-square']\" [fixedWidth]=\"true\" size=\"lg\" class=\"checked cb-check\" *ngIf=\"!hideIcons\"></fa-icon>\n\t\t\t<fa-icon [icon]=\"['fas', 'square']\" [fixedWidth]=\"true\" size=\"lg\" class=\"unchecked cb-check\" *ngIf=\"!hideIcons\"></fa-icon>\n\t\t\t<div *ngIf=\"!box.isEdit\" class=\"d-flex\">\n\t\t\t\t<ng-container *ngFor=\"let field of box.fields; let j = index;\">\n\t\t\t\t\t<span class=\"cb-text label{{j+1}}\" *ngIf=\"field.label\">{{field.label}}</span>\n\t\t\t\t\t<span class=\"cb-text field{{j+1}}\">{{field.value}}</span>\n\t\t\t\t</ng-container>\n\t\t\t\t<span class=\"cb-text body\" [innerHTML]=\"box.body\"></span>\n\t\t\t\t<!-- <span class=\"bblu mx-1\">{{box.id}}</span> -->\n\t\t\t</div>\n\t\t</label>\n\n\t\t<div class=\"cb-form d-flex\" *ngIf=\"box.isEdit\">\n\t\t\t<ng-container *ngFor=\"let field of box.fields; let j = index;\">\n\t\t\t\t<label for=\"{{'field' + (j+1) + '_' + i}}\" *ngIf=\"field.label\">{{field.label}}</label>\n\t\t\t\t<input \n\t\t\t\t\t[type]=\"field.type\" \n\t\t\t\t\tname=\"field{{j+1}}\" \n\t\t\t\t\tid=\"{{'field' + (j+1) + '_' + i}}\" \n\t\t\t\t\t[value]=\"field.value\" \n\t\t\t\t\tclass=\"form-control mr-2\" \n\t\t\t\t\t[attr.placeholder]=\"field.placeholder\"\n\t\t\t\t\t/>\n\t\t\t</ng-container>\n\t\t</div>\n\n\t\t<div class=\"cb-btns ml-auto d-flex\">\n\t\t\t<div *ngIf=\"!box.isEdit\" class=\"cb-btn\" (click)=\"toggleEdit('open', box)\">Edit</div>\n\t\t\t<div *ngIf=\"box.isEdit\" class=\"d-flex\">\n\t\t\t\t<div class=\"cb-btn text-success\" (click)=\"save(box, i)\">Save</div>\n\t\t\t\t<div class=\"cb-btn text-danger\" (click)=\"delete(box)\">Delete</div>\n\t\t\t\t<div class=\"cb-btn\" (click)=\"toggleEdit('close', box)\">Cancel</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n"
            }]
    }], function () { return []; }, { checkboxData: [{
            type: Input
        }], checkboxActive: [{
            type: Input
        }], inputFormGroup: [{
            type: Input
        }], arrayName: [{
            type: Input
        }], className: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }], hideIcons: [{
            type: Input
        }], header: [{
            type: Input
        }], emitter: [{
            type: Output
        }] }); })();

class CheckboxGroupComponent {
    constructor() {
        this.checkboxActive = [];
        this.inputFormGroup = new FormGroup({});
        this.arrayName = "";
        this.className = "";
        this.consoleLogs = false;
        this.hideIcons = false;
        this.items = [];
        this.itemsData = [];
        this.ranId = 'cbg' + Math.floor(Math.random() * 1000) + '_'; //need prefix so no identical ids if more than one CBG is on the stage
    }
    ngOnInit() {
        if (this.consoleLogs)
            console.group('CheckboxGroupComponent');
        if (this.consoleLogs)
            console.log('inputFormGroup:', this.inputFormGroup);
        if (this.consoleLogs)
            console.log('checkboxData:', this.checkboxData);
        if (this.consoleLogs)
            console.log('checkboxActive:', this.checkboxActive);
        if (this.consoleLogs)
            console.log('arrayName:', this.arrayName);
        if (this.consoleLogs)
            console.log('className:', this.className);
        if (this.consoleLogs)
            console.log('ranId:', this.ranId);
        this.items = this.checkboxData;
        this.addCheckboxes();
        if (this.consoleLogs)
            console.groupEnd();
    }
    ngOnDestroy() {
        this.inputFormGroup.get(this.arrayName).clear();
        if (this.consoleLogs)
            console.log('CheckboxGroupComponent.ngOnDestroy');
    }
    /**
     * Add checkboxes dynamically
     */
    addCheckboxes() {
        if (this.consoleLogs)
            console.log('addCheckboxes.items:', this.items);
        if (this.items) {
            this.itemsData = [];
            this.items.forEach((box) => {
                if (this.consoleLogs)
                    console.group('box:', box);
                this.itemsData.push({ id: box.id, name: box.name, icon: box.icon });
                const isActive = (this.checkboxActive.length > 0 && this.checkboxActive.indexOf(box.id) > -1) ? true : false;
                if (this.consoleLogs)
                    console.log('this.checkboxActive.length:', this.checkboxActive.length);
                if (this.consoleLogs)
                    console.log('this.checkboxActive.indexOf(box.id):', this.checkboxActive.indexOf(box.id));
                if (this.consoleLogs)
                    console.log('isActive:', isActive);
                //const isActive = false;
                this.inputFormGroup.get(this.arrayName).push(new FormControl(isActive));
                if (this.consoleLogs)
                    console.groupEnd();
            });
        }
    }
}
CheckboxGroupComponent.ɵfac = function CheckboxGroupComponent_Factory(t) { return new (t || CheckboxGroupComponent)(); };
CheckboxGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CheckboxGroupComponent, selectors: [["ascedia-checkbox-group"]], inputs: { checkboxActive: "checkboxActive", inputFormGroup: "inputFormGroup", arrayName: "arrayName", className: "className", consoleLogs: "consoleLogs", hideIcons: "hideIcons", checkboxData: "checkboxData" }, decls: 1, vars: 1, consts: [[3, "class", "formGroup", "ngClass", 4, "ngIf"], [3, "formGroup", "ngClass"], ["class", "form-group", 3, "formArrayName", 4, "ngFor", "ngForOf"], [1, "form-group", 3, "formArrayName"], ["type", "checkbox", 3, "formControlName", "id"], [3, "for"], ["size", "lg", "class", "checked cb-check", 3, "icon", "fixedWidth", 4, "ngIf"], ["size", "lg", "class", "unchecked cb-check", 3, "icon", "fixedWidth", 4, "ngIf"], ["class", "ml-1 cb-icon", 3, "icon", "fixedWidth", 4, "ngIf"], [1, "cb-text"], ["size", "lg", 1, "checked", "cb-check", 3, "icon", "fixedWidth"], ["size", "lg", 1, "unchecked", "cb-check", 3, "icon", "fixedWidth"], [1, "ml-1", "cb-icon", 3, "icon", "fixedWidth"]], template: function CheckboxGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CheckboxGroupComponent_div_0_Template, 2, 8, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.checkboxData);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc4.FormArrayName, ɵngcc4.CheckboxControlValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc2.FaIconComponent], encapsulation: 2 });
CheckboxGroupComponent.ctorParameters = () => [];
CheckboxGroupComponent.propDecorators = {
    checkboxData: [{ type: Input }],
    checkboxActive: [{ type: Input }],
    inputFormGroup: [{ type: Input }],
    arrayName: [{ type: Input }],
    className: [{ type: Input }],
    consoleLogs: [{ type: Input }],
    hideIcons: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxGroupComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-checkbox-group',
                template: "<div class=\"checkbox-group {{className}}\" \n\t[formGroup]=\"inputFormGroup\" \n\t*ngIf=\"checkboxData\" \n\t[ngClass]=\"{'hide-icons': hideIcons}\">\n\t<div class=\"form-group\" \n\t\tformArrayName=\"{{arrayName}}\"\n\t\t*ngFor=\"let order of checkboxData; let i = index\">\n\t\t<input type=\"checkbox\" \n\t\t\t[formControlName]=\"i\" \n\t\t\tid=\"{{ranId}}{{i}}\"\n\t\t\t>\n\t\t<label for=\"{{ranId}}{{i}}\">\n\t\t\t<fa-icon [icon]=\"['fas', 'check-square']\" [fixedWidth]=\"true\" size=\"lg\" class=\"checked cb-check\" *ngIf=\"!hideIcons\"></fa-icon>\n\t\t\t<fa-icon [icon]=\"['fas', 'square']\" [fixedWidth]=\"true\" size=\"lg\" class=\"unchecked cb-check\" *ngIf=\"!hideIcons\"></fa-icon>\n\t\t\t<fa-icon [icon]=\"['fas', order.icon]\" [fixedWidth]=\"true\" *ngIf=\"order.icon && !hideIcons\" class=\"ml-1 cb-icon\"></fa-icon>\n\t\t\t<span class=\"cb-text\">{{checkboxData[i].name}}</span>\n\t\t</label>\n\t</div>\n</div>\n"
            }]
    }], function () { return []; }, { checkboxActive: [{
            type: Input
        }], inputFormGroup: [{
            type: Input
        }], arrayName: [{
            type: Input
        }], className: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }], hideIcons: [{
            type: Input
        }], checkboxData: [{
            type: Input
        }] }); })();

class FileUploaderGroupComponent {
    constructor() {
        this.className = "";
        this.labelPrefix = "";
        this.labelShowNumber = true;
        this.uploaderIds = [];
        this.consoleLogs = false;
        this.hideRemoveButtons = false;
        this.emitter = new EventEmitter();
        this.uploadFiles = [];
    }
    ngOnInit() {
    }
    /**
     * On select file handler
     * @param $event
     * @param file
     */
    onSelectFile($event, file) {
        if (this.consoleLogs)
            console.log('FileUploaderGroupComponent.onSelectFile.file:', file, $event);
        this.uploadFiles.push(file);
        this.notifyUploadFiles();
        //debugger;
    }
    /**
     * Remove uploader from component, update files array
     * @param index
     * @param id
     */
    removeUploader(index, id) {
        if (this.consoleLogs)
            console.log('FileUploaderGroupComponent.removeUploader: ', index, id);
        this.uploaderIds.splice(this.uploaderIds.indexOf(id), 1);
        this.uploadFiles.splice(this.uploadFiles.indexOf(this.uploadFiles[index]), 1);
        if (this.consoleLogs)
            console.log('FileUploaderGroupComponent.uploaderIds:', this.uploaderIds);
        if (this.consoleLogs)
            console.log('FileUploaderGroupComponent.uploadFiles:', this.uploadFiles);
        this.notifyUploadFiles();
    }
    /**
     * Resetter that gets called from parent component
     */
    resetUploader() {
        if (this.consoleLogs)
            console.log('FileUploaderGroupComponent.resetUploader()');
        this.uploaderIds = [];
        this.uploadFiles = [];
        if (this.consoleLogs)
            console.log('FileUploaderGroupComponent.uploaderIds:', this.uploaderIds);
        if (this.consoleLogs)
            console.log('FileUploaderGroupComponent.uploadFiles:', this.uploadFiles);
        this.notifyUploadFiles();
    }
    /**
     * Notify parent component that uploadFiles changed
     */
    notifyUploadFiles() {
        if (this.consoleLogs)
            console.log('notifyUploadFiles()');
        this.emitter.emit(this.uploadFiles);
    }
}
FileUploaderGroupComponent.ɵfac = function FileUploaderGroupComponent_Factory(t) { return new (t || FileUploaderGroupComponent)(); };
FileUploaderGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FileUploaderGroupComponent, selectors: [["ascedia-file-uploader-group"]], inputs: { className: "className", labelPrefix: "labelPrefix", labelShowNumber: "labelShowNumber", uploaderIds: "uploaderIds", consoleLogs: "consoleLogs", hideRemoveButtons: "hideRemoveButtons" }, outputs: { emitter: "emitter" }, decls: 1, vars: 1, consts: [[3, "class", 4, "ngFor", "ngForOf"], [1, "form-label", "mb-1"], [4, "ngIf"], [1, "d-flex", "align-items-center"], [1, "custom-file"], [1, "custom-file-label", 3, "for"], ["type", "file", 1, "custom-file-input", 3, "id", "change"], ["dynamicElement", ""], ["class", "btn btn-link text-danger d-flex ml-3 pr-0", 3, "click", 4, "ngIf"], [1, "btn", "btn-link", "text-danger", "d-flex", "ml-3", "pr-0", 3, "click"], [1, "mr-2", 3, "icon"]], template: function FileUploaderGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FileUploaderGroupComponent_div_0_Template, 13, 10, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.uploaderIds);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.FaIconComponent], encapsulation: 2 });
FileUploaderGroupComponent.ctorParameters = () => [];
FileUploaderGroupComponent.propDecorators = {
    className: [{ type: Input }],
    labelPrefix: [{ type: Input }],
    labelShowNumber: [{ type: Input }],
    uploaderIds: [{ type: Input }],
    consoleLogs: [{ type: Input }],
    hideRemoveButtons: [{ type: Input }],
    emitter: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileUploaderGroupComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-file-uploader-group',
                template: "<div class=\"file-uploader-row {{className}}\"\n\t*ngFor=\"let n of uploaderIds; let i = index;\"\n\t>\n\t<label class=\"form-label mb-1\">\n\t\t<span>{{labelPrefix}}</span>\n\t\t<span *ngIf=\"labelShowNumber\"> #{{i}}</span>\n\t</label>\n\t<div class=\"d-flex align-items-center\">\n\t\t<div class=\"custom-file\">\n\t\t\t<label class=\"custom-file-label\" for=\"{{'asset' + i}}\">\n\t\t\t\t<span *ngIf=\"!dynamicElement.files[0]\"></span>\n\t\t\t\t<span *ngIf=\"dynamicElement.files[0]\">{{dynamicElement.files[0].name}}</span>\n\t\t\t</label>\n\t\t\t<input class=\"custom-file-input\" \n\t\t\t\ttype=\"file\" \n\t\t\t\tid=\"{{'asset' + i}}\"\n\t\t\t\t#dynamicElement\n\t\t\t\t(change)=\"onSelectFile($event, dynamicElement.files[0])\"\n\t\t\t\t>\n\t\t</div>\n\t\t\n\t\t<div class=\"btn btn-link text-danger d-flex ml-3 pr-0\"\n\t\t\t(click)=\"removeUploader(i,n)\"\n\t\t\t*ngIf=\"!hideRemoveButtons\">\n\t\t\t<fa-icon [icon]=\"['fas', 'trash-alt']\" class=\"mr-2\"></fa-icon>\n\t\t\t<span>Remove</span>\n\t\t</div>\n\t</div>\n</div>"
            }]
    }], function () { return []; }, { className: [{
            type: Input
        }], labelPrefix: [{
            type: Input
        }], labelShowNumber: [{
            type: Input
        }], uploaderIds: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }], hideRemoveButtons: [{
            type: Input
        }], emitter: [{
            type: Output
        }] }); })();

class InfoBoxAccordionComponent {
    constructor() {
        this.className = '';
        this.textColor = '#000000';
        this.lineColor = '#000000';
        this.infoBoxes = [];
    }
    ngOnInit() {
        //console.log('InfoBarComponent.OnInit');
    }
    /**
     * Toggle infobox open/closed, close others
     * @param box
     */
    toggleInfoBox(box) {
        if (!this.infoBoxes)
            return;
        this.infoBoxes.forEach(item => {
            //console.log('box:', box, 'vs', item);
            if (box == item) {
                //console.log('found match ^^');
                item.isActive = !item.isActive;
            }
            else {
                if (item.isActive)
                    item.isActive = false;
            }
        });
    }
}
InfoBoxAccordionComponent.ɵfac = function InfoBoxAccordionComponent_Factory(t) { return new (t || InfoBoxAccordionComponent)(); };
InfoBoxAccordionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: InfoBoxAccordionComponent, selectors: [["ascedia-info-box-accordion"]], inputs: { className: "className", textColor: "textColor", lineColor: "lineColor", infoBoxes: "infoBoxes" }, decls: 2, vars: 7, consts: [[3, "ngStyle"], ["class", "info-box", 3, "ngClass", "ngStyle", "click", 4, "ngFor", "ngForOf"], [1, "info-box", 3, "ngClass", "ngStyle", "click"], ["class", "info-box-icon", 4, "ngIf"], [1, "info-box-title"], [1, "info-box-toggle", "ml-auto"], [3, "icon", 4, "ngIf"], [1, "info-box-subTitle", 3, "innerHTML"], [1, "info-box-links", "mb-3"], ["class", "info-box-link", 3, "href", "target", "ngClass", 4, "ngFor", "ngForOf"], [1, "info-box-icon"], [3, "icon"], [1, "info-box-link", 3, "href", "target", "ngClass"]], template: function InfoBoxAccordionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, InfoBoxAccordionComponent_div_1_Template, 10, 12, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("info-box-accordion ", ctx.className, "");
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c5, ctx.textColor));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.infoBoxes);
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgForOf, ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc2.FaIconComponent], encapsulation: 2 });
InfoBoxAccordionComponent.propDecorators = {
    className: [{ type: Input }],
    textColor: [{ type: Input }],
    lineColor: [{ type: Input }],
    infoBoxes: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InfoBoxAccordionComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-info-box-accordion',
                template: "<div class=\"info-box-accordion {{className}}\"\r\n\t[ngStyle]=\"{'color': textColor}\">\r\n\t<div class=\"info-box\" \r\n\t\t*ngFor=\"let box of infoBoxes; let i = index;\"\r\n\t\t(click)=\"toggleInfoBox(box)\"\r\n\t\t[ngClass]=\"{'active': box.isActive}\"\r\n\t\t[ngStyle]=\"{'border-color': lineColor}\"\r\n\t\t>\r\n\t\t<div class=\"info-box-icon\"  *ngIf=\"box.icon\"><fa-icon [icon]=\"[box.iconPrefix, box.icon]\"></fa-icon></div>\r\n\t\t<div class=\"info-box-title\">{{box.title}}</div>\r\n\t\t<div class=\"info-box-toggle ml-auto\">\r\n\t\t\t<fa-icon [icon]=\"['fal', 'plus']\" *ngIf=\"!box.isActive\"></fa-icon>\r\n\t\t\t<fa-icon [icon]=\"['fal', 'minus']\" *ngIf=\"box.isActive\"></fa-icon>\r\n\t\t</div>\r\n\t\t<div class=\"info-box-subTitle\" [innerHTML]=\"box.subTitle\"></div>\r\n\r\n\t\t<div class=\"info-box-links mb-3\">\r\n\t\t\t<a [href]=\"link.href\" \r\n\t\t\t\t[target]=\"link.target\" \r\n\t\t\t\t[ngClass]=\"link.className\"\r\n\t\t\t\t*ngFor=\"let link of box.links;\"\r\n\t\t\t\tclass=\"info-box-link\">{{link.title}}</a>\r\n\t\t</div>\r\n\t</div>\r\n</div>"
            }]
    }], function () { return []; }, { className: [{
            type: Input
        }], textColor: [{
            type: Input
        }], lineColor: [{
            type: Input
        }], infoBoxes: [{
            type: Input
        }] }); })();

class ImageGridComponent {
    constructor() {
        this.className = '';
        this.imageGrid = [];
        this.showTitles = false;
        this.toResizeMs = 200;
        this.window = { width: 0, height: 0 };
        //public breakpoint = Breakpoint;
        this.isMobile = false;
    }
    ngOnInit() {
        //console.log('ImageGridComponent.OnInit.loading:', this.loading);
    }
    /**
     * Listen for window resize
     * @param event
     */
    onResize(event) {
        //console.log('Resize', event.target.innerWidth, 'x', event.target.innerHeight);
        clearTimeout(this.toResize);
        this.toResize = setTimeout(() => {
            this.getWindowDims();
        }, this.toResizeMs);
    }
    /**
     * Get window dimensions
     * @param event
     */
    getWindowDims(event = null) {
        if (event) {
            this.window.width = event.target.innerWidth;
            this.window.height = event.target.innerHeight;
        }
        else {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
        //console.log('window:', this.window);
        if (this.window.width < 992 /* lg */) { //
            this.isMobile = true;
        }
        else {
            this.isMobile = false;
        }
        //console.log('getWindowDims.isMobile:', this.isMobile);
    }
}
ImageGridComponent.ɵfac = function ImageGridComponent_Factory(t) { return new (t || ImageGridComponent)(); };
ImageGridComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ImageGridComponent, selectors: [["ascedia-image-grid"]], hostBindings: function ImageGridComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function ImageGridComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { className: "className", imageGrid: "imageGrid", showTitles: "showTitles" }, decls: 2, vars: 4, consts: [["class", "image-grid-item", 3, "routerLink", "ngStyle", 4, "ngFor", "ngForOf"], [1, "image-grid-item", 3, "routerLink", "ngStyle"], ["class", "title-wrapper", 4, "ngIf"], [1, "title-wrapper"], [1, "title"]], template: function ImageGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, ImageGridComponent_a_1_Template, 2, 5, "a", 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("image-grid ", ctx.className, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.imageGrid);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc3.RouterLinkWithHref, ɵngcc1.NgStyle, ɵngcc1.NgIf], encapsulation: 2 });
ImageGridComponent.propDecorators = {
    className: [{ type: Input }],
    imageGrid: [{ type: Input }],
    showTitles: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ImageGridComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-image-grid',
                template: "<div class=\"image-grid {{className}}\">\r\n\t<a *ngFor=\"let item of imageGrid; let i = index;\"\r\n\t\tclass=\"image-grid-item\"\r\n\t\t[routerLink]=\"item.href\"\r\n\t\t[ngStyle]=\"{'background-image': isMobile ? 'url(' + item.image + ')' : 'url(' + item.image2x + ')'}\"\r\n\t\t>\r\n\t\t<div class=\"title-wrapper\" *ngIf=\"showTitles\">\r\n\t\t\t<div class=\"title\">{{item.title}}</div>\r\n\t\t</div>\r\n\t</a>\r\n</div>"
            }]
    }], function () { return []; }, { className: [{
            type: Input
        }], imageGrid: [{
            type: Input
        }], showTitles: [{
            type: Input
        }], 
    /**
     * Listen for window resize
     * @param event
     */
    onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

class HorizCardComponent {
    constructor() {
        this.cards = [];
        this.className = '';
        this.consoleLogs = false;
    }
    ngOnInit() {
        //console.log('HorizCardComponent.OnInit.options:', this.options);
    }
}
HorizCardComponent.ɵfac = function HorizCardComponent_Factory(t) { return new (t || HorizCardComponent)(); };
HorizCardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HorizCardComponent, selectors: [["ascedia-horiz-card"]], inputs: { cards: "cards", className: "className", consoleLogs: "consoleLogs" }, decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"], [3, "class", 4, "ngFor", "ngForOf"], [1, "card-img-wrapper", "w-md-50"], ["media", "(min-width:992px)", 3, "srcset"], ["media", "(min-width:300px)", 3, "srcset"], [1, "card-img", 3, "src", "alt"], [1, "card-body", "w-md-50"], ["class", "card-subtitle", 4, "ngIf"], [1, "card-title"], [1, "card-text", 3, "innerHTML"], [3, "href", "target", "class", 4, "ngIf"], [1, "card-subtitle"], [3, "href", "target"]], template: function HorizCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HorizCardComponent_div_0_Template, 2, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.cards);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf], encapsulation: 2 });
HorizCardComponent.propDecorators = {
    cards: [{ type: Input }],
    className: [{ type: Input }],
    consoleLogs: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HorizCardComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-horiz-card',
                template: "<div class=\"horiz-cards {{className}}\" *ngIf=\"cards\">\r\n\t<div class=\"card horiz-card {{card.className}}\" *ngFor=\"let card of cards\">\r\n\t\t<div class=\"card-img-wrapper w-md-50\">\r\n\t\t\t<picture>\r\n\t\t\t\t<source media=\"(min-width:992px)\" srcset=\"{{card.image.url2x}}\">\r\n\t\t\t\t<source media=\"(min-width:300px)\" srcset=\"{{card.image.url}}\">\r\n\t\t\t\t<img class=\"card-img\" [src]=\"card.image.url\" [alt]=\"card.image.alt\">\r\n\t\t\t  </picture>\r\n\t\t\t\r\n\t\t</div>\r\n\t\t<div class=\"card-body w-md-50\">\r\n\t\t<h6 class=\"card-subtitle\" *ngIf=\"card.subTitle\">{{card.subTitle}}</h6>\r\n\t\t<h3 class=\"card-title\">{{card.title}}</h3>\r\n\t\t<div class=\"card-text\" [innerHTML]=\"card.body\"></div>\r\n\t\t<a *ngIf=\"card.cta\"\r\n\t\t\t[href]=\"card.cta.href\"\r\n\t\t\t[target]=\"card.cta.target\"\r\n\t\t\tclass=\"{{card.cta.className}}\">{{card.cta.title}}</a>\r\n\t\t</div>\r\n\t</div>\r\n</div>"
            }]
    }], function () { return []; }, { cards: [{
            type: Input
        }], className: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }] }); })();

class JumbotronComponent {
    constructor() {
        this.options = {};
        this.consoleLogs = false;
        this.isMobile = false;
        this.toResizeMs = 100;
        this.window = { width: 0, height: 0 };
    }
    //public breakpoint = Breakpoint;
    ngOnInit() {
        if (this.consoleLogs)
            console.log('JumbotronComponent.OnInit.options:', this.options);
        this.toResize = setTimeout(() => {
            this.getWindowDims();
        }, this.toResizeMs);
    }
    /**
     * Listen for window resize
     * @param event
    */
    onResize(event) {
        //console.log(event.target.innerWidth, 'x', event.target.innerHeight);
        clearTimeout(this.toResize);
        this.toResize = setTimeout(() => {
            this.getWindowDims(event);
        }, this.toResizeMs);
    }
    /**
     * Get window dimensions
     * @param event
    */
    getWindowDims(event = null) {
        //if(this.consoleLogs) console.log('Jumbotron.getWindowDims()');
        if (event) {
            this.window.width = event.target.innerWidth;
            this.window.height = event.target.innerHeight;
        }
        else {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
        //if(this.consoleLogs) console.log('Jumbotron.window:', this.window);
        if (this.window.width < 768 /* md */) {
            this.isMobile = true;
        }
        else {
            this.isMobile = false;
        }
        //if(this.consoleLogs) console.log('Jumbotron.isMobile:', this.isMobile);
    }
}
JumbotronComponent.ɵfac = function JumbotronComponent_Factory(t) { return new (t || JumbotronComponent)(); };
JumbotronComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: JumbotronComponent, selectors: [["ascedia-jumbotron"]], hostBindings: function JumbotronComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function JumbotronComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { options: "options", consoleLogs: "consoleLogs" }, decls: 5, vars: 7, consts: [[1, "jumbotron", "jumbotron-bg", 3, "ngClass", "ngStyle"], [1, "jumbotron-info"], ["class", "jumbotron-title", 3, "innerHTML", 4, "ngIf"], [1, "jumbotron-subtitle", 3, "innerHTML"], [1, "jumbotron-title", 3, "innerHTML"]], template: function JumbotronComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, JumbotronComponent_h1_2_Template, 1, 1, "h1", 2);
        ɵngcc0.ɵɵtemplate(3, JumbotronComponent_div_3_Template, 1, 1, "div", 2);
        ɵngcc0.ɵɵelement(4, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.options.className)("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c15, ctx.isMobile ? "url(" + ctx.options.image.url + ")" : "url(" + ctx.options.image.url2x + ")"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.options.titleIsH1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.options.titleIsH1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.options.subTitle, ɵngcc0.ɵɵsanitizeHtml);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgStyle, ɵngcc1.NgIf], encapsulation: 2 });
JumbotronComponent.propDecorators = {
    options: [{ type: Input }],
    consoleLogs: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(JumbotronComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-jumbotron',
                template: "<div class=\"jumbotron jumbotron-bg\"\r\n\t[ngClass]=\"options.className\"\r\n\t[ngStyle]=\"{'background-image': isMobile ? 'url(' + options.image.url + ')' : 'url(' + options.image.url2x + ')'}\">\r\n\t<div class=\"jumbotron-info\">\r\n\t\t<h1 [innerHTML]=\"options.title\" class=\"jumbotron-title\" *ngIf=\"options.titleIsH1\"></h1>\r\n\t\t<div [innerHTML]=\"options.title\" class=\"jumbotron-title\" *ngIf=\"!options.titleIsH1\"></div>\r\n\t\t<div [innerHTML]=\"options.subTitle\" class=\"jumbotron-subtitle\"></div>\r\n\t</div>\r\n</div>"
            }]
    }], function () { return []; }, { options: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }], 
    /**
     * Listen for window resize
     * @param event
    */
    onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

class ListButtonGroupComponent {
    //public breakpoint = Breakpoint;
    constructor(router) {
        this.router = router;
        this.text = '';
        this.className = '';
        this.isShowStatusText = false;
        this.isShowStatusDot = false;
        this.buttonList = [];
        this.consoleLogs = false;
        this.isMobile = false;
        this.toResizeMs = 100;
        this.window = { width: 0, height: 0 };
        setTimeout(() => {
            this.getWindowDims();
            if (this.consoleLogs)
                console.log('LBG.buttonList:', this.buttonList);
        }, this.toResizeMs);
    }
    // /**
    //  * Btn Click - if ONLY ONE button, make the whole row also clickable
    //  * @param btn 
    //  * 
    //  * 
    // 	(click)="btnClick(btn, $event)"
    //  */
    // public btnClick(btn: ListButton, evt: any) {
    // 	console.log('btnClick.btn ->', btn);
    // 	console.log('evt:', evt);
    // 	if(btn.buttons?.length == 1){
    // 		const sub = btn.buttons[0];
    // 		console.log('sub:', sub);
    // 		if(sub?.fragment) {
    // 			this.router.navigate([sub.href], {fragment: sub.fragment});
    // 		} else {
    // 			this.router.navigate([sub.href]);
    // 		}
    // 		evt.preventDefault();
    // 	}
    // }
    // public btnClick(btn: ListButton) {
    // 	if(this.consoleLogs) console.log('goto.href ->', btn.href);
    // 	const hrefArr = String(btn.href).split('#');
    // 	if(this.consoleLogs) console.log('hrefArr:', hrefArr);
    // 	if(hrefArr.length > 1) {
    // 		this.router.navigate([hrefArr[0]], {fragment: hrefArr[1]});
    // 	} else {
    // 		this.router.navigate([btn.href]);
    // 	}
    // }
    /**
     * Listen for window resize
     * @param event
     */
    onResize(event) {
        //console.log(event.target.innerWidth, 'x', event.target.innerHeight);
        clearTimeout(this.toResize);
        this.toResize = setTimeout(() => {
            this.getWindowDims(event);
        }, this.toResizeMs);
    }
    /**
     * Get window dimensions
     * @param event
     */
    getWindowDims(event = null) {
        if (event) {
            this.window.width = event.target.innerWidth;
            this.window.height = event.target.innerHeight;
        }
        else {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
        if (this.consoleLogs)
            console.log('LBG.window:', this.window);
        this.updateComponent();
    }
    updateComponent() {
        let wasMobile = this.isMobile;
        if (this.window.width < 768 /* md */) {
            this.isMobile = true;
        }
        else {
            this.isMobile = false;
        }
        if (this.consoleLogs)
            console.log('LBG.isMobile:', this.isMobile);
    }
}
ListButtonGroupComponent.ɵfac = function ListButtonGroupComponent_Factory(t) { return new (t || ListButtonGroupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router)); };
ListButtonGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ListButtonGroupComponent, selectors: [["ascedia-list-button-group"]], hostBindings: function ListButtonGroupComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function ListButtonGroupComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { text: "text", className: "className", isShowStatusText: "isShowStatusText", isShowStatusDot: "isShowStatusDot", buttonList: "buttonList", consoleLogs: "consoleLogs" }, decls: 3, vars: 8, consts: [[3, "ngClass"], ["class", "font-weight-bold list-button-group-title p-3 d-flex", 4, "ngIf"], [3, "class", "ngClass", "mouseover", "mouseout", 4, "ngFor", "ngForOf"], [1, "font-weight-bold", "list-button-group-title", "p-3", "d-flex"], [3, "ngClass", "mouseover", "mouseout"], ["class", "status-dot mr-1", 4, "ngIf"], ["class", "status-text mr-3", 3, "innerHTML", 4, "ngIf"], [1, "ml-1", "mr-3", "btn-title", 3, "routerLink", "fragment"], [1, "font-weight-bold", "title", 3, "innerHTML"], ["class", "ml-1 mr-3 body", 3, "innerHTML", 4, "ngIf"], [3, "routerLink", "fragment", "class", 4, "ngFor", "ngForOf"], [1, "status-dot", "mr-1"], [1, "status-text", "mr-3", 3, "innerHTML"], [1, "ml-1", "mr-3", "body", 3, "innerHTML"], [3, "routerLink", "fragment"], [3, "icon"], [1, "ml-2"]], template: function ListButtonGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ListButtonGroupComponent_div_1_Template, 3, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, ListButtonGroupComponent_div_2_Template, 7, 15, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("list-button-group ", ctx.className, "");
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c17, ctx.isMobile));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.text);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.buttonList);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc3.RouterLinkWithHref, ɵngcc2.FaIconComponent], encapsulation: 2 });
ListButtonGroupComponent.ctorParameters = () => [
    { type: Router }
];
ListButtonGroupComponent.propDecorators = {
    text: [{ type: Input }],
    className: [{ type: Input }],
    isShowStatusText: [{ type: Input }],
    isShowStatusDot: [{ type: Input }],
    buttonList: [{ type: Input }],
    consoleLogs: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListButtonGroupComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-list-button-group',
                template: "<div class=\"list-button-group {{className}}\" [ngClass]=\"{'is-mobile': isMobile}\" >\r\n\t<div class=\"font-weight-bold list-button-group-title p-3 d-flex\" *ngIf=\"text\">\r\n\t\t<span>{{text}}</span>\r\n\t</div>\r\n\t\r\n\t<div *ngFor=\"let btn of buttonList;\" \r\n\t\tclass=\"d-flex list-button {{btn.className}}\"\r\n\t\t[ngClass]=\"{'is-hover': btn.isHover}\"\r\n\t\t(mouseover)=\"btn.isHover=true\" \r\n\t\t(mouseout)=\"btn.isHover=false\"\r\n\t\t>\r\n\t\t<span class=\"status-dot mr-1\" *ngIf=\"isShowStatusDot\"></span>\r\n\t\t<span class=\"status-text mr-3\" *ngIf=\"isShowStatusText\" [innerHTML]=\"btn.status\"></span>\r\n\t\t<a [routerLink]=\"[btn.buttons[0].href]\" fragment=\"{{btn.buttons[0].fragment}}\" class=\"ml-1 mr-3 btn-title\"><span class=\"font-weight-bold title\" [innerHTML]=\"btn.title\"></span></a>\r\n\t\t<!-- <span class=\"ml-1 mr-3 font-weight-bold title\" [innerHTML]=\"btn.title\"></span> -->\r\n\t\t<span class=\"ml-1 mr-3 body\" *ngIf=\"btn.body\" [innerHTML]=\"btn.body\"></span>\r\n\t\t\r\n\t\t<a *ngFor=\"let sub of btn.buttons; let i = index;\"\r\n\t\t\t[routerLink]=\"[sub.href]\"\r\n\t\t\tfragment=\"{{sub.fragment}}\"\r\n\t\t\tclass=\"btn-primary pill align-items-center mobile-hover-flex clickable btn-sub-{{i}}\">\r\n\t\t\t<fa-icon [icon]=\"[sub.iconPrefix, sub.icon]\"></fa-icon>\r\n\t\t\t<span class=\"ml-2\">{{sub.title}}</span>\r\n\t\t</a>\r\n\r\n\t</div>\r\n\r\n</div>\r\n\r\n"
            }]
    }], function () { return [{ type: ɵngcc3.Router }]; }, { text: [{
            type: Input
        }], className: [{
            type: Input
        }], isShowStatusText: [{
            type: Input
        }], isShowStatusDot: [{
            type: Input
        }], buttonList: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }], 
    // /**
    //  * Btn Click - if ONLY ONE button, make the whole row also clickable
    //  * @param btn 
    //  * 
    //  * 
    // 	(click)="btnClick(btn, $event)"
    //  */
    // public btnClick(btn: ListButton, evt: any) {
    // 	console.log('btnClick.btn ->', btn);
    // 	console.log('evt:', evt);
    // 	if(btn.buttons?.length == 1){
    // 		const sub = btn.buttons[0];
    // 		console.log('sub:', sub);
    // 		if(sub?.fragment) {
    // 			this.router.navigate([sub.href], {fragment: sub.fragment});
    // 		} else {
    // 			this.router.navigate([sub.href]);
    // 		}
    // 		evt.preventDefault();
    // 	}
    // }
    // public btnClick(btn: ListButton) {
    // 	if(this.consoleLogs) console.log('goto.href ->', btn.href);
    // 	const hrefArr = String(btn.href).split('#');
    // 	if(this.consoleLogs) console.log('hrefArr:', hrefArr);
    // 	if(hrefArr.length > 1) {
    // 		this.router.navigate([hrefArr[0]], {fragment: hrefArr[1]});
    // 	} else {
    // 		this.router.navigate([btn.href]);
    // 	}
    // }
    /**
     * Listen for window resize
     * @param event
     */
    onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

class LoadingStatusComponent {
    constructor() {
        this.text = '';
        this.textColor = '#000000';
        this.icon = false;
        this.className = '';
        this.loading = true;
    }
    ngOnChanges() {
        //console.log('LoadingStatusComponent.ngOnChanges.loading:', this.loading);
    }
}
LoadingStatusComponent.ɵfac = function LoadingStatusComponent_Factory(t) { return new (t || LoadingStatusComponent)(); };
LoadingStatusComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoadingStatusComponent, selectors: [["ascedia-loading-status"]], inputs: { text: "text", textColor: "textColor", icon: "icon", className: "className", loading: "loading" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "class", "color", 4, "ngIf"], ["class", "my-2 display-5", 4, "ngIf"], [4, "ngIf"], [1, "my-2", "display-5"], [1, "lds-roller"]], template: function LoadingStatusComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LoadingStatusComponent_div_0_Template, 3, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
LoadingStatusComponent.propDecorators = {
    text: [{ type: Input }],
    textColor: [{ type: Input }],
    icon: [{ type: Input }],
    className: [{ type: Input }],
    loading: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingStatusComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-loading-status',
                template: "<div class=\"loading-status {{className}} text-center\" [style.color]=\"textColor\" *ngIf=\"loading\">\r\n\t<div *ngIf=\"text\" class=\"my-2 display-5\">{{text}}</div>\r\n\t<div *ngIf=\"icon\">\r\n\t\t<div class=\"lds-roller\">\r\n\t\t\t<div></div>\r\n\t\t\t<div></div>\r\n\t\t\t<div></div>\r\n\t\t\t<div></div>\r\n\t\t\t<div></div>\r\n\t\t\t<div></div>\r\n\t\t\t<div></div>\r\n\t\t\t<div></div>\r\n\t\t</div>\r\n\t</div>\r\n</div>"
            }]
    }], function () { return []; }, { text: [{
            type: Input
        }], textColor: [{
            type: Input
        }], icon: [{
            type: Input
        }], className: [{
            type: Input
        }], loading: [{
            type: Input
        }] }); })();

class NavbarComponent {
    constructor(router) {
        this.router = router;
        this.text = '';
        this.imgSrc = '';
        this.imgAlt = '';
        this.className = '';
        this.navItems = [];
        this.navbarIsShow = false;
        this.navbarIsSidebar = false;
        this.navbarOpenMenuLevels = 0; //using method argument because of async loading
        this.showArrows = true;
        this.userRole = '';
        this.userSubRole = '';
        this.consoleLogs = false;
        this.onClick = new EventEmitter();
        this.emitter = new EventEmitter();
        this.isMobile = false;
        this.toResizeMs = 100;
        this.window = { width: 0, height: 0 };
    }
    ngOnInit() {
        if (this.consoleLogs)
            console.group('Navbar.OnInit()');
        if (this.consoleLogs)
            console.log('Navbar.navbarIsSidebar:', this.navbarIsSidebar);
        if (this.consoleLogs)
            console.log('Navbar.navItems:', this.navItems);
        if (this.consoleLogs)
            console.log('Navbar.navbarOpenMenuLevels:', this.navbarOpenMenuLevels);
        if (this.consoleLogs)
            console.log('Navbar.userRole:', this.userRole);
        if (this.consoleLogs)
            console.log('Navbar.userSubRole:', this.userSubRole);
        if (this.consoleLogs)
            console.groupEnd();
        if (this.navbarIsSidebar) {
            this.toResize = setTimeout(() => {
                this.getWindowDims();
            }, this.toResizeMs);
        }
        if (this.navbarOpenMenuLevels > 0 && this.navItems)
            this.openMenuLevels();
    }
    ngOnChanges() {
        if (this.consoleLogs)
            console.group('Navbar.ngOnChanges()');
        if (this.consoleLogs)
            console.log('Navbar.navItems:', this.navItems);
        if (this.consoleLogs)
            console.log('Navbar.userRole:', this.userRole);
        if (this.consoleLogs)
            console.log('Navbar.userSubRole:', this.userSubRole);
        if (this.consoleLogs)
            console.groupEnd();
    }
    /**
     * List for document click to close menu if not clicking a nav item
    */
    hostDocumentClick() {
        //console.log('hostDocumentClick.close menu');
        if (!this.navbarIsSidebar) {
            this.closeAllMenus();
        }
    }
    /**
     * Listen for window scroll
     * @param event
    */
    onScroll(event) {
        //console.log('onScroll.event:', event);
        if (!this.navbarIsSidebar) {
            clearTimeout(this.toResize);
            this.toResize = setTimeout(() => {
                this.closeAllMenus();
            }, this.toResizeMs);
        }
    }
    /**
     * Listen for window resize
     * @param event
    */
    onResize(event) {
        //console.log('window:resize', event.target.innerWidth, 'x', event.target.innerHeight);
        if (this.navbarIsSidebar) {
            clearTimeout(this.toResize);
            this.toResize = setTimeout(() => {
                this.getWindowDims(event);
            }, this.toResizeMs);
        }
    }
    closeAllMenus() {
        this.activeL1 = null;
        this.activeL2 = null;
        this.activeL3 = null;
        this.activeL4 = null;
        this.closeInactiveSubmenus();
    }
    /**
     * Open all drop down menus for each level noted
     * Called from parent component
     */
    openMenuLevels(levels = 0) {
        //if(this.consoleLogs) console.log('Navbar.openMenuLevels()', levels, this.navItems?.length);
        if (!this.navItems)
            return;
        this.navItems.forEach(item => {
            var _a;
            item.isVisible = true;
            //if(this.consoleLogs) console.log('Navbar.openMenuLevels.item:', item);
            if (levels > 1) {
                (_a = item.children) === null || _a === void 0 ? void 0 : _a.forEach(child => {
                    child.isVisible = true;
                    //console.log('openMenuLevels.item.child:', child);
                    // if(levels > 2) {
                    // 	console.log('OPEN LEVEL 3!! todo: add more nested loops');
                    // }
                });
            }
        });
    }
    /**
     * Handle navItem clicks
     * @param item
     */
    navItemClick(evt, item, index) {
        var _a;
        //console.log('navItemClick.level:', item.level, 'index:', index, item);
        //console.log('navItemClick.evt', evt);
        evt.stopPropagation();
        if (item.children) {
            item.isVisible = !item.isVisible;
            //console.log('toggle submenu to:', item.isVisible);
        }
        else {
            let stopProcessing = false;
            if (item.clickCallback) {
                stopProcessing = ((_a = item.clickCallback()) !== null && _a !== void 0 ? _a : false);
            }
            if (stopProcessing) {
                //console.log('Navbar.goto.href ->', item.href);
                this.router.navigate([item.href]);
            }
            if (!this.navbarIsSidebar)
                this.closeAllMenus();
            if (this.isMobile) {
                this.navbarIsShow = false;
            }
        }
        if (item.level == 1) {
            this.activeL1 = index;
            this.activeL2 = null;
            this.activeL3 = null;
            this.activeL4 = null;
        }
        else if (item.level == 2) {
            this.activeL2 = index;
            this.activeL3 = null;
            this.activeL4 = null;
        }
        else if (item.level == 3) {
            this.activeL3 = index;
            this.activeL4 = null;
        }
        else if (item.level == 4) {
            this.activeL4 = index;
        }
        //console.log('activeLevel:', this.activeL1, this.activeL2, this.activeL3, this.activeL4);
        if ((item.isVisible || !item.children) && this.navbarOpenMenuLevels == 0) {
            this.closeInactiveSubmenus();
        }
    }
    /**
     * Close inactive submenus
     */
    closeInactiveSubmenus() {
        //console.log('closeInactiveSubmenus()');
        for (let i = 0; i < this.navItems.length; i++) {
            let item = this.navItems[i];
            //console.log('level-1:', item.isVisible, item.children?.length);
            if (item.children) {
                if (i != this.activeL1)
                    item.isVisible = false;
                //console.log('^^^ close all children below');
                for (let j = 0; j < item.children.length; j++) {
                    let child = item.children[j];
                    //console.log('--- level-2:', child.isVisible, child.children?.length);
                    if (child.children) {
                        if (j != this.activeL2)
                            child.isVisible = false;
                        //console.log('^^^^^^ close all grand children below');
                        for (let k = 0; k < child.children.length; k++) {
                            let grandchild = child.children[k];
                            //console.log('------ level-3:', grandchild.isVisible, grandchild.children?.length);
                            if (grandchild.children) {
                                if (k != this.activeL3)
                                    grandchild.isVisible = false;
                                //console.log('^^^^^^^^^ close all great grand children below');
                            }
                        }
                    }
                }
            }
        }
    }
    /**
     * Get window dimensions
     * @param event
    */
    getWindowDims(event = null) {
        if (this.consoleLogs)
            console.log('Navbar.getWindowDims()');
        if (event) {
            this.window.width = event.target.innerWidth;
            this.window.height = event.target.innerHeight;
        }
        else {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
        if (this.consoleLogs)
            console.log('Navbar.window:', this.window);
        this.updateComponent();
    }
    updateComponent() {
        let wasMobile = this.isMobile;
        if (this.window.width < 768 /* md */) {
            this.isMobile = true;
        }
        else {
            this.isMobile = false;
        }
        if (this.consoleLogs)
            console.log('Navbar.isMobile:', this.isMobile);
        if (wasMobile != this.isMobile) {
            //var changed, update stage
            this.navbarIsShow = !this.isMobile;
            this.emitter.emit(this.navbarIsShow);
            if (this.consoleLogs)
                console.log('Navbar.navbarIsShow:', this.navbarIsShow);
        }
    }
    /*
    Check privileges

    Angular best practices frown upon using functions in templates. They execute too many times because angular cant read the value in a function. I used this to check my statement below. There are so many combos of options now.

    display:
        if no roles/subroles
        if item has roles, check it against userRole
        if item has subroles, check it against userSubRole

    The method below should be the same as this, but easier to read vv

    ( !item.roles && !item.subroles ) ||
    ( item.roles && !item.subroles && (!this.userRole || (this.userRole && item.roles.includes(this.userRole))) ) ||
    ( !item.roles && item.subroles && (!this.userSubRole || (this.userSubRole && item.subroles.includes(this.userSubRole))) ) ||
    ( item.roles && item.subroles && (!this.userRole || (this.userRole && item.roles.includes(this.userRole))) ) && (!this.userSubRole || (this.userSubRole && item.subroles.includes(this.userSubRole)))

    */
    checkPrivileges(item) {
        // console.group('checkPrivileges()');
        // console.log('item', item);
        // console.log('role', this.userRole, 'vs', item?.roles);
        // console.log('subrole', this.userSubRole, 'vs', item?.subroles);
        let isAvailable = true;
        if (this.userRole && item.roles) {
            //console.log('check userRole against roles');
            if (!item.roles.includes(this.userRole)) {
                //console.log('userRole is not included. DENIED ^^');
                isAvailable = false;
            }
        }
        if (this.userSubRole && item.subroles) {
            //console.log('check userSubRole against subroles');
            if (!item.subroles.includes(this.userSubRole)) {
                //console.log('userSubRole is not included. DENIED ^^');
                isAvailable = false;
            }
        }
        //console.log('isAvailable', isAvailable);
        //console.groupEnd();
        return isAvailable;
    }
}
NavbarComponent.ɵfac = function NavbarComponent_Factory(t) { return new (t || NavbarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router)); };
NavbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavbarComponent, selectors: [["ascedia-navbar"]], hostBindings: function NavbarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NavbarComponent_click_HostBindingHandler() { return ctx.hostDocumentClick(); }, false, ɵngcc0.ɵɵresolveDocument)("scroll", function NavbarComponent_scroll_HostBindingHandler($event) { return ctx.onScroll($event); }, false, ɵngcc0.ɵɵresolveWindow)("resize", function NavbarComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { text: "text", imgSrc: "imgSrc", imgAlt: "imgAlt", className: "className", navItems: "navItems", navbarIsShow: "navbarIsShow", navbarIsSidebar: "navbarIsSidebar", navbarOpenMenuLevels: "navbarOpenMenuLevels", showArrows: "showArrows", userRole: "userRole", userSubRole: "userSubRole", consoleLogs: "consoleLogs" }, outputs: { onClick: "onClick", emitter: "emitter" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 13, consts: [[3, "ngClass"], [1, "container-fluid", "navbar-content"], [1, "navbar-content-inner"], ["href", "/", 1, "navbar-brand"], [4, "ngIf"], [3, "src", "alt", 4, "ngIf"], ["type", "button", "data-bs-toggle", "collapse", "data-bs-target", "#navbarNav", "aria-controls", "navbarNav", "aria-expanded", "false", "aria-label", "Toggle navigation", 1, "navbar-toggler", 3, "click"], [1, "navbar-toggler-icon"], ["id", "navbarNav", 1, "collapse", "navbar-collapse", 3, "ngClass"], ["class", "loading", 4, "ngIf"], ["class", "navbar-nav", 4, "ngIf"], [3, "src", "alt"], [1, "loading"], [3, "loading", "icon"], [1, "navbar-nav"], [3, "class", "ngClass", 4, "ngFor", "ngForOf"], ["class", "nav-link d-flex level-1", 3, "wmRedirect", "click", 4, "ngIf"], ["class", "dropdown-menu", 3, "ngClass", 4, "ngIf"], [1, "nav-link", "d-flex", "level-1", 3, "wmRedirect", "click"], [3, "icon", "fixedWidth", "ngClass", 4, "ngIf"], ["class", "chevron-toggle", 4, "ngIf"], ["class", "badge", 4, "ngIf"], [3, "icon", "fixedWidth", "ngClass"], [1, "chevron-toggle"], [3, "icon", 4, "ngIf"], [3, "icon"], [1, "badge"], [1, "dropdown-menu", 3, "ngClass"], [4, "ngFor", "ngForOf"], [1, "dropdown-item", "level-2", 3, "wmRedirect", "click"], ["class", "mr-2", 3, "icon", "fixedWidth", 4, "ngIf"], ["class", "submenu dropdown-menu", 3, "ngClass", 4, "ngIf"], [1, "mr-2", 3, "icon", "fixedWidth"], [1, "submenu", "dropdown-menu", 3, "ngClass"], [1, "dropdown-item", "level-3", 3, "wmRedirect", "click"], [1, "dropdown-item", "level-4", 3, "wmRedirect", "click"]], template: function NavbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "a", 3);
        ɵngcc0.ɵɵtemplate(4, NavbarComponent_span_4_Template, 2, 1, "span", 4);
        ɵngcc0.ɵɵtemplate(5, NavbarComponent_img_5_Template, 1, 2, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 6);
        ɵngcc0.ɵɵlistener("click", function NavbarComponent_Template_button_click_6_listener() { return ctx.navbarIsShow = !ctx.navbarIsShow; });
        ɵngcc0.ɵɵelement(7, "span", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 8);
        ɵngcc0.ɵɵtemplate(9, NavbarComponent_div_9_Template, 2, 2, "div", 9);
        ɵngcc0.ɵɵtemplate(10, NavbarComponent_ul_10_Template, 2, 1, "ul", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("navbar ", ctx.className, "");
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c19, ctx.navbarIsShow));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.text);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.imgSrc);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c19, ctx.navbarIsShow));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.navItems || ctx.navItems.length == 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.navItems && ctx.navItems.length > 0);
    } }, directives: function () { return [ɵngcc1.NgClass, ɵngcc1.NgIf, LoadingStatusComponent, ɵngcc1.NgForOf, RedirectWithHrefDirective, ɵngcc2.FaIconComponent]; }, encapsulation: 2 });
NavbarComponent.ctorParameters = () => [
    { type: Router }
];
NavbarComponent.propDecorators = {
    text: [{ type: Input }],
    imgSrc: [{ type: Input }],
    imgAlt: [{ type: Input }],
    className: [{ type: Input }],
    navItems: [{ type: Input }],
    navbarIsShow: [{ type: Input }],
    navbarIsSidebar: [{ type: Input }],
    navbarOpenMenuLevels: [{ type: Input }],
    showArrows: [{ type: Input }],
    userRole: [{ type: Input }],
    userSubRole: [{ type: Input }],
    consoleLogs: [{ type: Input }],
    onClick: [{ type: Output }],
    emitter: [{ type: Output }],
    hostDocumentClick: [{ type: HostListener, args: ["document:click",] }],
    onScroll: [{ type: HostListener, args: ['window:scroll', ['$event'],] }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavbarComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-navbar',
                template: "\r\n<nav class=\"navbar {{className}}\" [ngClass]=\"{'show': navbarIsShow}\">\r\n\t<div class=\"container-fluid navbar-content\">\r\n\t\t<div class=\"navbar-content-inner\">\r\n\t\t\t<a class=\"navbar-brand\" href=\"/\"><span *ngIf=\"text\">{{text}}</span><img *ngIf=\"imgSrc\" src=\"{{imgSrc}}\" alt=\"{{imgAlt}}\"></a>\r\n\t\t\t<!-- <div class=\"bred text-small\">{{userRole}} - {{userSubRole}}</div> -->\r\n\t\t\t<button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarNav\" aria-controls=\"navbarNav\" aria-expanded=\"false\" aria-label=\"Toggle navigation\" (click)=\"navbarIsShow = !navbarIsShow\">\r\n\t\t\t\t<span class=\"navbar-toggler-icon\"></span>\r\n\t\t\t</button>\r\n\t\t\t<div class=\"collapse navbar-collapse\" [ngClass]=\"{'show': navbarIsShow}\" id=\"navbarNav\">\r\n\t\t\t\t\r\n\t\t\t\t<div class=\"loading\" \r\n\t\t\t\t\t*ngIf=\"!navItems || navItems.length == 0\">\r\n\t\t\t\t\t<ascedia-loading-status [loading]=\"true\" [icon]=\"true\"></ascedia-loading-status>\r\n\t\t\t\t</div>\r\n\t\t\t\t<ul class=\"navbar-nav\" *ngIf=\"navItems && navItems.length > 0\">\r\n\r\n\t\t\t\t\t<li class=\"nav-item {{item.className}}\" *ngFor=\"let item of navItems; let i = index;\" [ngClass]=\"{'dropdown': item.children}\">\r\n\r\n\t\t\t\t\t\t<!-- checkPrivileges(item) -->\r\n\t\t\t\t\t\t<a class=\"nav-link d-flex level-1\" \r\n\t\t\t\t\t\t\t(click)=\"navItemClick($event, item, i)\" \r\n\t\t\t\t\t\t\t[wmRedirect]=\"item.children ? '#' : item.href\"\r\n\t\t\t\t\t\t\t*ngIf=\"( !item.roles && !item.subroles ) ||\r\n\t\t\t\t\t\t\t( item.roles && !item.subroles && (!userRole || (userRole && item.roles.includes(userRole))) ) ||\r\n\t\t\t\t\t\t\t( !item.roles && item.subroles && (!userSubRole || (userSubRole && item.subroles.includes(userSubRole))) ) ||\r\n\t\t\t\t\t\t\t( item.roles && item.subroles && (!userRole || (userRole && item.roles.includes(userRole))) ) && (!userSubRole || (userSubRole && item.subroles.includes(userSubRole)))\"\r\n\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t<fa-icon [icon]=\"[item.iconPrefix, item.icon]\" [fixedWidth]=\"true\" *ngIf=\"item.icon\"  [ngClass]=\"{'mr-2': item.title}\"></fa-icon>\r\n\t\t\t\t\t\t\t<!-- <span>{{item.title}} - {{item.roles | json}} - {{item.subroles | json}}</span> -->\r\n\t\t\t\t\t\t\t<span>{{item.title}}</span>\r\n\t\t\t\t\t\t\t<div *ngIf=\"item.children && showArrows\" class=\"chevron-toggle\">\r\n\t\t\t\t\t\t\t\t<fa-icon [icon]=\"['fas', 'chevron-down']\" *ngIf=\"!item.isVisible\"></fa-icon>\r\n\t\t\t\t\t\t\t\t<fa-icon [icon]=\"['fas', 'chevron-up']\" *ngIf=\"item.isVisible\"></fa-icon>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div *ngIf=\"item.badge\" class=\"badge\"><span>{{item.badge}}</span></div>\r\n\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\r\n\r\n\t\t\t\t\t\t<ul *ngIf=\"item.children && (!item.roles || item.roles.includes(userRole))\" class=\"dropdown-menu\" [ngClass]=\"{'show': item.isVisible}\">\r\n\t\t\t\t\t\t\t<li *ngFor=\"let child of item.children; let j = index;\">\r\n\r\n\t\t\t\t\t\t\t\t<!-- checkPrivileges(child) -->\r\n\t\t\t\t\t\t\t\t<ng-container \r\n\t\t\t\t\t\t\t\t\t*ngIf=\" ( !child.roles && !child.subroles ) ||\r\n\t\t\t\t\t\t\t\t\t( child.roles && !child.subroles && (!userRole || (userRole && child.roles.includes(userRole))) ) ||\r\n\t\t\t\t\t\t\t\t\t( !child.roles && child.subroles && (!userSubRole || (userSubRole && child.subroles.includes(userSubRole))) ) ||\r\n\t\t\t\t\t\t\t\t\t( child.roles && child.subroles && (!userRole || (userRole && child.roles.includes(userRole))) ) && (!userSubRole || (userSubRole && child.subroles.includes(userSubRole)))\"\r\n\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t<a class=\"dropdown-item level-2\" \r\n\t\t\t\t\t\t\t\t\t\t(click)=\"navItemClick($event, child, j)\"\r\n\t\t\t\t\t\t\t\t\t\t[wmRedirect]=\"child.children ? null : child.href\"\r\n\t\t\t\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\t\t<fa-icon [icon]=\"[child.iconPrefix, child.icon]\" [fixedWidth]=\"true\" *ngIf=\"child.icon\" class=\"mr-2\"></fa-icon>\r\n\t\t\t\t\t\t\t\t\t\t<!-- <span class=\"bred\">{{child.title}} - {{child.roles | json}} - {{userSubRole}} - {{child.subroles | json}} <span *ngIf=\"child?.subroles\">{{child?.subroles.includes(userSubRole)}}</span></span> -->\r\n\t\t\t\t\t\t\t\t\t\t<span>{{child.title}}</span>\r\n\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"child.children && showArrows\" class=\"chevron-toggle\">\r\n\t\t\t\t\t\t\t\t\t\t\t<fa-icon [icon]=\"['fas', 'chevron-down']\" *ngIf=\"!child.isVisible\"></fa-icon>\r\n\t\t\t\t\t\t\t\t\t\t\t<fa-icon [icon]=\"['fas', 'chevron-up']\" *ngIf=\"child.isVisible\"></fa-icon>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"child.badge\" class=\"badge\"><span>{{child.badge}}</span></div>\r\n\t\t\t\t\t\t\t\t\t</a>\r\n\r\n\t\t\t\t\t\t\t\t\t<ul *ngIf=\"child.children\" class=\"submenu dropdown-menu\" [ngClass]=\"{'show': child.isVisible}\">\r\n\t\t\t\t\t\t\t\t\t\t<li *ngFor=\"let grandchild of child.children; let k = index;\">\r\n\t\t\t\t\t\t\t\t\t\t\t<a class=\"dropdown-item level-3\" \r\n\t\t\t\t\t\t\t\t\t\t\t\t(click)=\"navItemClick($event, grandchild, k)\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t[wmRedirect]=\"grandchild.children ? null : grandchild.href\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span>{{grandchild.title}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"grandchild.children && showArrows\" class=\"chevron-toggle\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<fa-icon [icon]=\"['fas', 'chevron-down']\" *ngIf=\"!grandchild.isVisible\"></fa-icon>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<fa-icon [icon]=\"['fas', 'chevron-up']\" *ngIf=\"grandchild.isVisible\"></fa-icon>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"grandchild.badge\" class=\"badge\"><span>{{grandchild.badge}}</span></div>\r\n\t\t\t\t\t\t\t\t\t\t\t</a>\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t<ul *ngIf=\"grandchild.children\" class=\"submenu dropdown-menu\" [ngClass]=\"{'show': grandchild.isVisible}\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<li *ngFor=\"let greatgrandchild of grandchild.children; let m = index;\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<a class=\"dropdown-item level-4\" \r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t(click)=\"navItemClick($event, greatgrandchild, m)\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t[wmRedirect]=\"greatgrandchild.children ? null : greatgrandchild.href\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>{{greatgrandchild.title}}</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div *ngIf=\"greatgrandchild.badge\" class=\"badge\"><span>{{greatgrandchild.badge}}</span></div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t\t\t\t\t</ul>\r\n\r\n\t\t\t\t\t\t\t\t\t\t</li>\r\n\t\t\t\t\t\t\t\t\t</ul>\r\n\r\n\t\t\t\t\t\t\t\t</ng-container>\r\n\r\n\r\n\t\t\t\t\t\t\t</li>\r\n\r\n\t\t\t\t\t\t</ul>\r\n\t\t\t\t\t</li>\r\n\r\n\t\t\t\t</ul>\r\n\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</nav>\r\n\r\n"
            }]
    }], function () { return [{ type: ɵngcc3.Router }]; }, { text: [{
            type: Input
        }], imgSrc: [{
            type: Input
        }], imgAlt: [{
            type: Input
        }], className: [{
            type: Input
        }], navItems: [{
            type: Input
        }], navbarIsShow: [{
            type: Input
        }], navbarIsSidebar: [{
            type: Input
        }], navbarOpenMenuLevels: [{
            type: Input
        }], showArrows: [{
            type: Input
        }], userRole: [{
            type: Input
        }], userSubRole: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }], onClick: [{
            type: Output
        }], emitter: [{
            type: Output
        }], 
    /**
     * List for document click to close menu if not clicking a nav item
    */
    hostDocumentClick: [{
            type: HostListener,
            args: ["document:click"]
        }], 
    /**
     * Listen for window scroll
     * @param event
    */
    onScroll: [{
            type: HostListener,
            args: ['window:scroll', ['$event']]
        }], 
    /**
     * Listen for window resize
     * @param event
    */
    onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

class PaginationComponent {
    constructor() {
        this.textNext = '';
        this.textPrev = '';
        this.iconNext = '';
        this.iconPrev = '';
        this.className = '';
        this.linkBase = '';
        this.pageCurrent = 0;
        this.pageLimit = 0;
        this.itemsCount = 0;
        this.consoleLogs = false;
        this.pageNext = 0;
        this.pagePrev = 0;
        this.buttonMax = 0;
        this.buttonArr = [];
    }
    // constructor() {
    // 	if(this.consoleLogs) console.log('PaginationComponent.constructor()');
    // }
    ngOnInit() {
        if (this.consoleLogs)
            console.log('PaginationComponent.ngOnInit()');
        this.updatePagination();
    }
    ngOnChanges() {
        if (this.consoleLogs)
            console.log('PaginationComponent.ngOnChanges()');
        this.updatePagination();
    }
    updatePagination() {
        if (this.consoleLogs)
            console.group('PaginationComponent.updatePagination()');
        if (this.consoleLogs)
            console.log('textNext:', this.textNext);
        if (this.consoleLogs)
            console.log('textPrev:', this.textPrev);
        if (this.consoleLogs)
            console.log('iconNext:', this.iconNext);
        if (this.consoleLogs)
            console.log('iconPrev:', this.iconPrev);
        if (this.consoleLogs)
            console.log('className:', this.className);
        if (this.consoleLogs)
            console.log('linkBase:', this.linkBase);
        if (this.consoleLogs)
            console.log('pageCurrent:', this.pageCurrent);
        if (this.consoleLogs)
            console.log('pageLimit:', this.pageLimit);
        if (this.consoleLogs)
            console.log('itemsCount:', this.itemsCount);
        this.buttonMax = Math.ceil(this.itemsCount / this.pageLimit);
        this.buttonArr = Array.from({ length: this.buttonMax }, (v, k) => k + 1);
        this.pagePrev = (this.pageCurrent > 1) ? this.pageCurrent - 1 : 1;
        this.pageNext = (this.pageCurrent < this.buttonMax) ? this.pageCurrent + 1 : this.buttonMax;
        //if(this.consoleLogs) console.log('buttonMax vs pageCurrent:', this.buttonMax == this.pageCurrent);
        if (this.consoleLogs)
            console.log('buttonMax:', this.buttonMax);
        if (this.consoleLogs)
            console.log('pagePrev:', this.pagePrev);
        if (this.consoleLogs)
            console.log('pageNext:', this.pageNext);
        if (this.consoleLogs)
            console.groupEnd();
    }
}
PaginationComponent.ɵfac = function PaginationComponent_Factory(t) { return new (t || PaginationComponent)(); };
PaginationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PaginationComponent, selectors: [["ascedia-pagination"]], inputs: { textNext: "textNext", textPrev: "textPrev", iconNext: "iconNext", iconPrev: "iconPrev", className: "className", linkBase: "linkBase", pageCurrent: "pageCurrent", pageLimit: "pageLimit", itemsCount: "itemsCount", consoleLogs: "consoleLogs" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"], [1, "page-item", 3, "ngClass"], [1, "page-link", 3, "routerLink", "queryParams"], [3, "icon", "ngClass", 4, "ngIf"], [4, "ngIf"], ["class", "page-item", 3, "ngClass", 4, "ngFor", "ngForOf"], [3, "icon", "ngClass"]], template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PaginationComponent_ul_0_Template, 10, 26, "ul", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttonArr.length > 1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc3.RouterLinkWithHref, ɵngcc1.NgForOf, ɵngcc2.FaIconComponent], encapsulation: 2 });
PaginationComponent.propDecorators = {
    textNext: [{ type: Input }],
    textPrev: [{ type: Input }],
    iconNext: [{ type: Input }],
    iconPrev: [{ type: Input }],
    className: [{ type: Input }],
    linkBase: [{ type: Input }],
    pageCurrent: [{ type: Input }],
    pageLimit: [{ type: Input }],
    itemsCount: [{ type: Input }],
    consoleLogs: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-pagination',
                template: "<ul class=\"pagination my-4 {{className}}\" *ngIf=\"buttonArr.length > 1\">\r\n\t<li class=\"page-item\"\r\n\t\t[ngClass]=\"{'disabled': pageCurrent == 1}\"\r\n\t\t>\r\n\t\t<a class=\"page-link\" [routerLink]=\"[linkBase]\" [queryParams]=\"{ page: pagePrev}\">\r\n\t\t\t<fa-icon *ngIf=\"iconPrev\" [icon]=\"['fas', iconPrev]\" [ngClass]=\"{'mr-2': textPrev}\"></fa-icon>\r\n\t\t\t<span *ngIf=\"textPrev\">{{textPrev}}</span>\r\n\t\t</a>\r\n\t</li>\r\n\r\n\t<li class=\"page-item\" \r\n\t\t*ngFor=\"let btn of buttonArr; let i = index;\"\r\n\t\t[ngClass]=\"{'active': i == pageCurrent - 1}\"\r\n\t\t>\r\n\t\t<a class=\"page-link\" [routerLink]=\"[linkBase]\" [queryParams]=\"{ page: i+1}\">{{i+1}}</a>\r\n\t</li>\r\n\r\n\t<li class=\"page-item\"\r\n\t\t[ngClass]=\"{'disabled': pageCurrent == buttonMax}\"\r\n\t\t>\r\n\t\t<a class=\"page-link\" [routerLink]=\"[linkBase]\" [queryParams]=\"{ page: pageNext}\">\r\n\t\t\t<span *ngIf=\"textNext\">{{textNext}}</span>\r\n\t\t\t<fa-icon *ngIf=\"iconNext\" [icon]=\"['fas', iconNext]\"  [ngClass]=\"{'ml-2': textNext}\"></fa-icon>\r\n\t\t</a>\r\n\t</li>\r\n</ul>"
            }]
    }], function () { return []; }, { textNext: [{
            type: Input
        }], textPrev: [{
            type: Input
        }], iconNext: [{
            type: Input
        }], iconPrev: [{
            type: Input
        }], className: [{
            type: Input
        }], linkBase: [{
            type: Input
        }], pageCurrent: [{
            type: Input
        }], pageLimit: [{
            type: Input
        }], itemsCount: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }] }); })();

SwiperCore.use([
    Navigation,
    Pagination,
    //Scrollbar,
    A11y,
    Lazy
    // Virtual,
    // Zoom,
    // Autoplay,
    // Thumbs,
    // Controller
]);
class SwiperBackgroundImageComponent {
    constructor() {
        this.text = '';
        this.className = '';
        this.sliderList = [];
        this.consoleLogs = false;
        this.breakpoints = {};
        this.pagination = false;
        this.config = {};
        //@Output() emitter: EventEmitter<any> = new EventEmitter<any>();
        this.ranNum = Math.floor(Math.random() * 100000); //need unique button classes for ID
        // public onImagesReady() {
        // 	console.log('SwiperBackgroundImageComponent.onImagesReady');
        // }
    }
    ngOnInit() {
        if (this.consoleLogs)
            console.log('SwiperComponent.ngOnInit.config:', this.config);
    }
    onSwiper(e) {
        if (this.consoleLogs)
            console.log('SwiperBackgroundImageComponent.onSwiper.e:', e);
    }
    onSlideChange() {
        if (this.consoleLogs)
            console.log('SwiperBackgroundImageComponent.onSlideChange');
    }
}
SwiperBackgroundImageComponent.ɵfac = function SwiperBackgroundImageComponent_Factory(t) { return new (t || SwiperBackgroundImageComponent)(); };
SwiperBackgroundImageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SwiperBackgroundImageComponent, selectors: [["ascedia-swiper-background-image"]], inputs: { text: "text", className: "className", sliderList: "sliderList", consoleLogs: "consoleLogs", breakpoints: "breakpoints", pagination: "pagination", config: "config" }, decls: 8, vars: 22, consts: [[1, "swiper-title", "mb-3", 3, "innerHTML"], [3, "config", "navigation", "pagination", "watchSlidesVisibility", "swiper", "slideChange"], [4, "ngFor", "ngForOf"], ["type", "button"], [3, "icon"], ["swiperSlide", ""], [1, "card", "mb-3"], [1, "swiper-slide-image", "card-image", "clickable", 3, "wmRedirect", "target"], ["data-sizes", "(max-width: 992px) 300px, 992px", 1, "swiper-lazy", 3, "src", "srcset"], ["class", "card-body clickable", 3, "wmRedirect", "target", 4, "ngIf"], [1, "card-body", "clickable", 3, "wmRedirect", "target"], [1, "card-title", 3, "innerHTML"], ["class", "card-text", 3, "innerHTML", 4, "ngIf"], [1, "card-text", 3, "innerHTML"]], template: function SwiperBackgroundImageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelement(1, "h2", 0);
        ɵngcc0.ɵɵelementStart(2, "swiper", 1);
        ɵngcc0.ɵɵlistener("swiper", function SwiperBackgroundImageComponent_Template_swiper_swiper_2_listener($event) { return ctx.onSwiper($event); })("slideChange", function SwiperBackgroundImageComponent_Template_swiper_slideChange_2_listener() { return ctx.onSlideChange(); });
        ɵngcc0.ɵɵtemplate(3, SwiperBackgroundImageComponent_3_Template, 1, 0, undefined, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 3);
        ɵngcc0.ɵɵelement(5, "fa-icon", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 3);
        ɵngcc0.ɵɵelement(7, "fa-icon", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("swiper-outer-container swiper-background-image ", ctx.className, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.text, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("config", ctx.config)("navigation", ɵngcc0.ɵɵpureFunction2(17, _c24, ".swiper-navigation-prev-" + ctx.ranNum, ".swiper-navigation-next-" + ctx.ranNum))("pagination", ctx.pagination)("watchSlidesVisibility", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.sliderList);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("swiper-navigation-prev-", ctx.ranNum, " swiper-navigation-prev");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(20, _c25));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("swiper-navigation-next-", ctx.ranNum, " swiper-navigation-next");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(21, _c26));
    } }, directives: function () { return [ɵngcc5.SwiperComponent, ɵngcc1.NgForOf, ɵngcc2.FaIconComponent, ɵngcc5.SwiperSlideDirective, RedirectWithHrefDirective, ɵngcc1.NgIf]; }, encapsulation: 2 });
SwiperBackgroundImageComponent.propDecorators = {
    text: [{ type: Input }],
    className: [{ type: Input }],
    sliderList: [{ type: Input }],
    consoleLogs: [{ type: Input }],
    breakpoints: [{ type: Input }],
    pagination: [{ type: Input }],
    config: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SwiperBackgroundImageComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-swiper-background-image',
                template: "<div class=\"swiper-outer-container swiper-background-image {{className}}\">\r\n\t<h2 class=\"swiper-title mb-3\" [innerHTML]=\"text\"></h2>\r\n\t<!-- [slidesPerView]=\"1.25\"\r\n\t\t[spaceBetween]=\"10\"\r\n\t[breakpoints]=\"breakpoints\"\r\n\t\t[lazy]=\"{'checkInView':true}\"\r\n\t\t[preloadImages]=\"false\" \r\n\t\t(imagesReady)=\"onImagesReady()\"\r\n\r\n\t\ttodo: move config: swiper options into stories to easier work with\r\n\r\n-->\r\n\t<swiper\r\n\t\t(swiper)=\"onSwiper($event)\"\r\n\t\t(slideChange)=\"onSlideChange()\"\r\n\t\r\n\t\t[config]=\"config\"\r\n\t\t[navigation]=\"{ prevEl: '.swiper-navigation-prev-' + ranNum, nextEl: '.swiper-navigation-next-' + ranNum }\"\r\n\t\t[pagination]=\"pagination\"\r\n\r\n\t\t[watchSlidesVisibility]=\"true\"\r\n\t\t>\r\n\t\t<ng-template swiperSlide *ngFor=\"let slide of sliderList; let i = index;\">\r\n\t\t\t<div class=\"card mb-3\">\r\n\t\t\t\t<a class=\"swiper-slide-image card-image clickable\"\r\n\t\t\t\t\t[wmRedirect]=\"slide.href\"\r\n\t\t\t\t\t[target]=\"slide.target\">\r\n\t\t\t\t\t<img\r\n\t\t\t\t\t\tdata-src=\"{{slide.image}}\"\r\n\t\t\t\t\t\tdata-srcset=\"{{slide.image}} 300w, {{slide.image2x}} 992w\"\r\n\t\t\t\t\t\tdata-sizes=\"(max-width: 992px) 300px, 992px\"\r\n\t\t\t\t\t\tclass=\"swiper-lazy\"\r\n\t\t\t\t\t/>\r\n\t\t\t\t</a>\r\n\t\t\t\t<a class=\"card-body clickable\"\r\n\t\t\t\t\t[wmRedirect]=\"slide.href\"\r\n\t\t\t\t\t[target]=\"slide.target\"\r\n\t\t\t\t\t*ngIf=\"slide.title || slide.subTitle\">\r\n\t\t\t\t\t<h5 class=\"card-title\" [innerHTML]=\"slide.title\"></h5>\r\n\t\t\t\t\t<div class=\"card-text\" *ngIf=\"slide.subTitle\" [innerHTML]=\"slide.subTitle\"></div>\r\n\t\t\t\t</a>\r\n\t\t\t</div>\r\n\t\t</ng-template>\r\n\t</swiper>\r\n\t<button type=\"button\" class=\"swiper-navigation-prev-{{ranNum}} swiper-navigation-prev\"><fa-icon [icon]=\"['fas', 'chevron-left']\"></fa-icon></button>\r\n\t<button type=\"button\" class=\"swiper-navigation-next-{{ranNum}} swiper-navigation-next\"><fa-icon [icon]=\"['fas', 'chevron-right']\"></fa-icon></button>\r\n</div>\r\n"
            }]
    }], function () { return []; }, { text: [{
            type: Input
        }], className: [{
            type: Input
        }], sliderList: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }], breakpoints: [{
            type: Input
        }], pagination: [{
            type: Input
        }], config: [{
            type: Input
        }] }); })();

SwiperCore.use([
    Navigation,
    Pagination,
    //Scrollbar,
    A11y,
    Lazy
    // Virtual,
    // Zoom,
    // Autoplay,
    // Thumbs,
    // Controller
]);
class SwiperCardImageComponent {
    constructor() {
        this.text = '';
        this.className = '';
        this.sliderList = [];
        this.consoleLogs = false;
        this.hasFavorites = false;
        this.breakpoints = {};
        this.pagination = false;
        this.toggleFavorite = new EventEmitter();
        //@Output() ctaClick: EventEmitter<any> = new EventEmitter<any>();
        this.ranNum = Math.floor(Math.random() * 100000); //need unique button classes for ID
        // public onCtaClick(slide: SwiperCardImage){
        // 	if(this.consoleLogs) console.log('onCtaClick.slide', slide);
        // 	this.ctaClick.emit(slide);
        // }
    }
    ngOnInit() {
        if (this.consoleLogs)
            console.log('SwiperComponent.ngOnInit.className:', this.className);
    }
    onSwiper(e) {
        if (this.consoleLogs)
            console.log('onSwiper.e:', e);
    }
    onSlideChange() {
        if (this.consoleLogs)
            console.log('onSlideChange');
    }
    onToggleFavorite(slide) {
        if (this.consoleLogs)
            console.log('onToggleFavorite.slide', slide);
        slide.isFavorite = !slide.isFavorite;
        this.toggleFavorite.emit(slide);
    }
}
SwiperCardImageComponent.ɵfac = function SwiperCardImageComponent_Factory(t) { return new (t || SwiperCardImageComponent)(); };
SwiperCardImageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SwiperCardImageComponent, selectors: [["ascedia-swiper-card-image"]], inputs: { text: "text", className: "className", sliderList: "sliderList", consoleLogs: "consoleLogs", hasFavorites: "hasFavorites", breakpoints: "breakpoints", pagination: "pagination" }, outputs: { toggleFavorite: "toggleFavorite" }, decls: 8, vars: 28, consts: [["class", "swiper-title mb-3", 4, "ngIf"], [3, "slidesPerView", "slidesPerGroup", "spaceBetween", "breakpoints", "navigation", "pagination", "lazy", "preloadImages", "watchSlidesVisibility", "swiper", "slideChange"], [4, "ngFor", "ngForOf"], ["type", "button"], [3, "icon"], [1, "swiper-title", "mb-3"], ["swiperSlide", ""], [1, "card", "mb-3"], [1, "swiper-slide-image", "card-image", "clickable", 3, "routerLink"], ["data-sizes", "(max-width: 992px) 300px, 992px", 1, "swiper-lazy", 3, "src", "srcset"], [1, "card-body", "clickable", 3, "routerLink"], ["class", "card-title", 3, "innerHTML", 4, "ngIf"], ["class", "card-text", 3, "innerHTML", 4, "ngIf"], ["class", "card-tertiary", 3, "innerHTML", 4, "ngIf"], [3, "wmRedirect", "class", 4, "ngIf"], ["class", "swiper-slide-favorite", 3, "click", 4, "ngIf"], [1, "card-title", 3, "innerHTML"], [1, "card-text", 3, "innerHTML"], [1, "card-tertiary", 3, "innerHTML"], [3, "wmRedirect"], [3, "icon", "class", 4, "ngIf"], [4, "ngIf"], [1, "swiper-slide-favorite", 3, "click"], ["class", "is-favorite", 3, "icon", 4, "ngIf"], [1, "stacked-icons"], ["class", "upper", 3, "icon", 4, "ngIf"], ["class", "lower", 3, "icon", 4, "ngIf"], [1, "is-favorite", 3, "icon"], [1, "upper", 3, "icon"], [1, "lower", 3, "icon"]], template: function SwiperCardImageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, SwiperCardImageComponent_h2_1_Template, 2, 1, "h2", 0);
        ɵngcc0.ɵɵelementStart(2, "swiper", 1);
        ɵngcc0.ɵɵlistener("swiper", function SwiperCardImageComponent_Template_swiper_swiper_2_listener($event) { return ctx.onSwiper($event); })("slideChange", function SwiperCardImageComponent_Template_swiper_slideChange_2_listener() { return ctx.onSlideChange(); });
        ɵngcc0.ɵɵtemplate(3, SwiperCardImageComponent_3_Template, 1, 0, undefined, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 3);
        ɵngcc0.ɵɵelement(5, "fa-icon", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 3);
        ɵngcc0.ɵɵelement(7, "fa-icon", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("swiper-outer-container swiper-card-image ", ctx.className, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.text);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("slidesPerView", 1.25)("slidesPerGroup", 1)("spaceBetween", 10)("breakpoints", ctx.breakpoints)("navigation", ɵngcc0.ɵɵpureFunction2(22, _c24, ".swiper-navigation-prev-" + ctx.ranNum, ".swiper-navigation-next-" + ctx.ranNum))("pagination", ctx.pagination)("lazy", ɵngcc0.ɵɵpureFunction0(25, _c29))("preloadImages", false)("watchSlidesVisibility", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.sliderList);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("swiper-navigation-prev-", ctx.ranNum, " swiper-navigation-prev");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(26, _c25));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("swiper-navigation-next-", ctx.ranNum, " swiper-navigation-next");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(27, _c26));
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc5.SwiperComponent, ɵngcc1.NgForOf, ɵngcc2.FaIconComponent, ɵngcc5.SwiperSlideDirective, ɵngcc3.RouterLinkWithHref, RedirectWithHrefDirective]; }, encapsulation: 2 });
SwiperCardImageComponent.propDecorators = {
    text: [{ type: Input }],
    className: [{ type: Input }],
    sliderList: [{ type: Input }],
    consoleLogs: [{ type: Input }],
    hasFavorites: [{ type: Input }],
    breakpoints: [{ type: Input }],
    pagination: [{ type: Input }],
    toggleFavorite: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SwiperCardImageComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-swiper-card-image',
                template: "<div class=\"swiper-outer-container swiper-card-image {{className}}\">\r\n\t<h2 class=\"swiper-title mb-3\" *ngIf=\"text\">{{text}}</h2>\r\n\t<swiper\r\n\t\t[slidesPerView]=\"1.25\"\r\n\t\t[slidesPerGroup]=\"1\"\r\n\t\t[spaceBetween]=\"10\"\r\n\t\t[breakpoints]=\"breakpoints\"\r\n\t\t(swiper)=\"onSwiper($event)\"\r\n\t\t(slideChange)=\"onSlideChange()\"\r\n\t\t[navigation]=\"{ prevEl: '.swiper-navigation-prev-' + ranNum, nextEl: '.swiper-navigation-next-' + ranNum }\"\r\n\t\t[pagination]=\"pagination\"\r\n\t\t[lazy]=\"{'checkInView':true}\"\r\n\t\t[preloadImages]=\"false\" \r\n\t\t[watchSlidesVisibility]=\"true\"\r\n\t\t>\r\n\t\t<ng-template swiperSlide *ngFor=\"let slide of sliderList; let i = index;\">\r\n\t\t\t<div class=\"card mb-3\">\r\n\t\t\t\t<a class=\"swiper-slide-image card-image clickable\"\r\n\t\t\t\t\t[routerLink]=\"slide.href\">\r\n\t\t\t\t\t<img\r\n\t\t\t\t\t\tdata-src=\"{{slide.image}}\"\r\n\t\t\t\t\t\tdata-srcset=\"{{slide.image}} 300w, {{slide.image2x}} 992w\"\r\n\t\t\t\t\t\tdata-sizes=\"(max-width: 992px) 300px, 992px\"\r\n\t\t\t\t\t\tclass=\"swiper-lazy\"\r\n\t\t\t\t\t/>\r\n\t\t\t\t\t<!-- <div class=\"swiper-lazy-preloader\"></div> -->\r\n\t\t\t\t</a>\r\n\t\t\t\t<a class=\"card-body clickable\"\r\n\t\t\t\t\t[routerLink]=\"slide.href\">\r\n\t\t\t\t\t<h5 *ngIf=\"slide.title\" class=\"card-title\" [innerHTML]=\"slide.title\"></h5>\r\n\t\t\t\t\t<div *ngIf=\"slide.subTitle\" class=\"card-text\" [innerHTML]=\"slide.subTitle\"></div>\r\n\t\t\t\t\t<div *ngIf=\"slide.tertiary\" class=\"card-tertiary\" [innerHTML]=\"slide.tertiary\"></div>\r\n\t\t\t\t</a>\r\n\t\t\t\t<!-- [target]=\"slide.cta.target ? slide.cta.target : '_self'\" -->\r\n\t\t\t\t<a *ngIf=\"slide.cta\"\r\n\t\t\t\t\t[wmRedirect]=\"slide.cta.href\" \r\n\t\t\t\t\tclass=\" {{slide.cta.className}}\">\r\n\t\t\t\t\t<fa-icon [icon]=\"[slide.cta.iconPrefix ? slide.cta.iconPrefix : 'fas', slide.cta.icon]\" \r\n\t\t\t\t\t\tclass=\"mr-1 {{slide.cta.iconClassName}}\" \r\n\t\t\t\t\t\t*ngIf=\"slide.cta.icon\"></fa-icon>\r\n\t\t\t\t\t<span *ngIf=\"slide.cta.title\">{{slide.cta.title}}</span>\r\n\t\t\t\t</a>\r\n\t\t\t\t<div class=\"swiper-slide-favorite\" \r\n\t\t\t\t\t*ngIf=\"hasFavorites\"\r\n\t\t\t\t\t(click)=\"onToggleFavorite(slide)\">\r\n\t\t\t\t\t<fa-icon [icon]=\"['fas', 'heart']\" class=\"is-favorite\" *ngIf=\"slide.isFavorite\"></fa-icon>\r\n\t\t\t\t\t<div class=\"stacked-icons\">\r\n\t\t\t\t\t\t<fa-icon [icon]=\"['fal', 'heart']\" class=\"upper\" *ngIf=\"!slide.isFavorite\"></fa-icon>\r\n\t\t\t\t\t\t<fa-icon [icon]=\"['fas', 'heart']\" class=\"lower\" *ngIf=\"!slide.isFavorite\"></fa-icon>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</ng-template>\r\n\t</swiper>\r\n\t<button type=\"button\" class=\"swiper-navigation-prev-{{ranNum}} swiper-navigation-prev\"><fa-icon [icon]=\"['fas', 'chevron-left']\"></fa-icon></button>\r\n\t<button type=\"button\" class=\"swiper-navigation-next-{{ranNum}} swiper-navigation-next\"><fa-icon [icon]=\"['fas', 'chevron-right']\"></fa-icon></button>\r\n</div>\r\n"
            }]
    }], function () { return []; }, { text: [{
            type: Input
        }], className: [{
            type: Input
        }], sliderList: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }], hasFavorites: [{
            type: Input
        }], breakpoints: [{
            type: Input
        }], pagination: [{
            type: Input
        }], toggleFavorite: [{
            type: Output
        }] }); })();

class SwiperJumbotronComponent {
    constructor() {
        this.text = '';
        this.className = '';
        this.sliderList = [];
        this.consoleLogs = false;
        this.breakpoints = {};
        this.pagination = false;
        this.isMobile = false;
        this.toResizeMs = 100;
        this.window = { width: 0, height: 0 };
        //public breakpoint = Breakpoint;
        this.ranNum = Math.floor(Math.random() * 100000); //need unique button classes for ID
    }
    ngOnInit() {
        if (this.consoleLogs)
            console.log('SwiperJumbotronComponent.OnInit.sliderList:', this.sliderList);
        this.toResize = setTimeout(() => {
            this.getWindowDims();
        }, this.toResizeMs);
    }
    /**
     * Listen for window resize
     * @param event
    */
    onResize(event) {
        //console.log(event.target.innerWidth, 'x', event.target.innerHeight);
        clearTimeout(this.toResize);
        this.toResize = setTimeout(() => {
            this.getWindowDims(event);
        }, this.toResizeMs);
    }
    /**
     * Get window dimensions
     * @param event
    */
    getWindowDims(event = null) {
        //if(this.consoleLogs) console.log('SwiperJumbotronComponent.getWindowDims()');
        if (event) {
            this.window.width = event.target.innerWidth;
            this.window.height = event.target.innerHeight;
        }
        else {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
        if (this.consoleLogs)
            console.log('SwiperJumbotronComponent.window:', this.window);
        if (this.window.width < 768 /* md */) {
            this.isMobile = true;
        }
        else {
            this.isMobile = false;
        }
        if (this.consoleLogs)
            console.log('SwiperJumbotronComponent.isMobile:', this.isMobile);
    }
    onSwiper(e) {
        if (this.consoleLogs)
            console.log('SwiperJumbotronComponent.onSwiper.e:', e);
    }
    onSlideChange() {
        if (this.consoleLogs)
            console.log('SwiperJumbotronComponent.onSlideChange');
    }
}
SwiperJumbotronComponent.ɵfac = function SwiperJumbotronComponent_Factory(t) { return new (t || SwiperJumbotronComponent)(); };
SwiperJumbotronComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SwiperJumbotronComponent, selectors: [["ascedia-swiper-jumbotron"]], hostBindings: function SwiperJumbotronComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function SwiperJumbotronComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { text: "text", className: "className", sliderList: "sliderList", consoleLogs: "consoleLogs", breakpoints: "breakpoints", pagination: "pagination" }, decls: 7, vars: 26, consts: [[3, "slidesPerView", "spaceBetween", "breakpoints", "navigation", "pagination", "lazy", "preloadImages", "watchSlidesVisibility", "swiper", "slideChange"], [4, "ngFor", "ngForOf"], ["type", "button"], [3, "icon"], ["swiperSlide", ""], [1, "jumbotron-slide", 3, "ngStyle"], [1, "jumbotron-info"], [1, "jumbotron-title"], ["class", "jumbotron-cta btn btn-white pill", 3, "href", "target", 4, "ngIf"], [1, "jumbotron-cta", "btn", "btn-white", "pill", 3, "href", "target"]], template: function SwiperJumbotronComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "swiper", 0);
        ɵngcc0.ɵɵlistener("swiper", function SwiperJumbotronComponent_Template_swiper_swiper_1_listener($event) { return ctx.onSwiper($event); })("slideChange", function SwiperJumbotronComponent_Template_swiper_slideChange_1_listener() { return ctx.onSlideChange(); });
        ɵngcc0.ɵɵtemplate(2, SwiperJumbotronComponent_2_Template, 1, 0, undefined, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 2);
        ɵngcc0.ɵɵelement(4, "fa-icon", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "button", 2);
        ɵngcc0.ɵɵelement(6, "fa-icon", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("swiper-outer-container swiper-jumbotron ", ctx.className, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("slidesPerView", 1)("spaceBetween", 0)("breakpoints", ctx.breakpoints)("navigation", ɵngcc0.ɵɵpureFunction2(20, _c24, ".swiper-navigation-prev-" + ctx.ranNum, ".swiper-navigation-next-" + ctx.ranNum))("pagination", ctx.pagination)("lazy", ɵngcc0.ɵɵpureFunction0(23, _c29))("preloadImages", false)("watchSlidesVisibility", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.sliderList);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("swiper-navigation-prev-", ctx.ranNum, " swiper-navigation-prev");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(24, _c25));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("swiper-navigation-next-", ctx.ranNum, " swiper-navigation-next");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("icon", ɵngcc0.ɵɵpureFunction0(25, _c26));
    } }, directives: [ɵngcc5.SwiperComponent, ɵngcc1.NgForOf, ɵngcc2.FaIconComponent, ɵngcc5.SwiperSlideDirective, ɵngcc1.NgStyle, ɵngcc1.NgIf], encapsulation: 2 });
SwiperJumbotronComponent.propDecorators = {
    text: [{ type: Input }],
    className: [{ type: Input }],
    sliderList: [{ type: Input }],
    consoleLogs: [{ type: Input }],
    breakpoints: [{ type: Input }],
    pagination: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SwiperJumbotronComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-swiper-jumbotron',
                template: "<div class=\"swiper-outer-container swiper-jumbotron {{className}}\">\r\n\t<swiper\r\n\t\t[slidesPerView]=\"1\"\r\n\t\t[spaceBetween]=\"0\"\r\n\t\t[breakpoints]=\"breakpoints\"\r\n\t\t(swiper)=\"onSwiper($event)\"\r\n\t\t(slideChange)=\"onSlideChange()\"\r\n\t\t[navigation]=\"{ prevEl: '.swiper-navigation-prev-' + ranNum, nextEl: '.swiper-navigation-next-' + ranNum }\"\r\n\t\t[pagination]=\"pagination\"\r\n\t\t[lazy]=\"{'checkInView':true}\"\r\n\t\t[preloadImages]=\"false\" \r\n\t\t[watchSlidesVisibility]=\"true\"\r\n\t\t>\r\n\t\t<ng-template swiperSlide *ngFor=\"let slide of sliderList; let i = index;\" >\r\n\t\t\t<div class=\"jumbotron-slide\"\r\n\t\t\t\t[ngStyle]=\"{'background-image': isMobile ? 'url(' + slide.image.url + ')' : 'url(' + slide.image.url2x + ')'}\"\r\n\t\t\t\t>\r\n\t\t\t\t<div class=\"jumbotron-info\">\r\n\t\t\t\t\t<div class=\"jumbotron-title\">{{slide.title}}</div>\r\n\t\t\t\t\t<a class=\"jumbotron-cta btn btn-white pill\" \r\n\t\t\t\t\t\t*ngIf=\"slide.cta\" \r\n\t\t\t\t\t\t[href]=\"slide.cta.href\"\r\n\t\t\t\t\t\t[target]=\"slide.cta.target\"\r\n\t\t\t\t\t\t>{{slide.cta.text}}</a>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</ng-template>\r\n\t</swiper>\r\n\t<button type=\"button\" class=\"swiper-navigation-prev-{{ranNum}} swiper-navigation-prev\"><fa-icon [icon]=\"['fas', 'chevron-left']\"></fa-icon></button>\r\n\t<button type=\"button\" class=\"swiper-navigation-next-{{ranNum}} swiper-navigation-next\"><fa-icon [icon]=\"['fas', 'chevron-right']\"></fa-icon></button>\r\n</div>"
            }]
    }], function () { return []; }, { text: [{
            type: Input
        }], className: [{
            type: Input
        }], sliderList: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }], breakpoints: [{
            type: Input
        }], pagination: [{
            type: Input
        }], 
    /**
     * Listen for window resize
     * @param event
    */
    onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

class TabGroupControllerComponent {
    //TODO-JK move styling to classes instead of in markup. need to override bootstrap utitlilties
    constructor() {
        this.tabList = [];
        this.className = null;
        this.text = null;
        this.icon = null;
        this.iconPrefix = 'fas'; //'far', 'fal', 'fas'
        this.parentId = null;
        this.consoleLogs = false;
        this.userRole = '';
        this.userSubRole = '';
        this.emitter = new EventEmitter();
        this.sectionActive = 0;
        this.sectionActiveSub = 0;
    }
    ngOnInit() {
        if (this.consoleLogs)
            console.log('TabGroupControllerComponent.ngOnInit');
    }
    ngOnChanges() {
        if (this.consoleLogs)
            console.group('TabGroupControllerComponent.ngOnChanges()');
        if (this.consoleLogs)
            console.log('TabGroupControllerComponent.userRole:', this.userRole);
        if (this.consoleLogs)
            console.log('TabGroupControllerComponent.userSubRole:', this.userSubRole);
        if (this.consoleLogs)
            console.groupEnd();
    }
    /**
     * Handle tab click
     * @param id
     */
    tabClick(tabId, notifyParent = true) {
        if (this.consoleLogs)
            console.log('TabGroupControllerComponent.tabClick.i:', tabId);
        let curTab = this.tabList.find(({ id }) => id === tabId);
        //console.log('curTab:', curTab);
        if (curTab === null || curTab === void 0 ? void 0 : curTab.disabled) {
            return;
        }
        if (this.parentId) {
            this.sectionActiveSub = tabId;
        }
        else {
            this.sectionActive = tabId;
            this.sectionActiveSub = 0;
        }
        //console.log('TabGroupControllerComponent.sectionActive:', this.sectionActive);
        if (this.consoleLogs && this.parentId)
            console.log('TabGroupControllerComponent.sectionActiveSub:', this.sectionActiveSub);
        if (notifyParent)
            this.notify();
    }
    /**
     * Notify parent component that something changed
     */
    notify() {
        const activeId = (this.parentId) ? (this.parentId + '-' + this.sectionActiveSub) : this.sectionActive;
        //console.log('TabGroupControllerComponent.notify()', activeId);
        this.emitter.emit(activeId);
    }
}
TabGroupControllerComponent.ɵfac = function TabGroupControllerComponent_Factory(t) { return new (t || TabGroupControllerComponent)(); };
TabGroupControllerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TabGroupControllerComponent, selectors: [["ascedia-tab-group-controller"]], inputs: { tabList: "tabList", className: "className", text: "text", icon: "icon", iconPrefix: "iconPrefix", parentId: "parentId", consoleLogs: "consoleLogs", userRole: "userRole", userSubRole: "userSubRole" }, outputs: { emitter: "emitter" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 5, consts: [["class", "px-3 py-3 font-weight-bold", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "px-3", "py-3", "font-weight-bold"], [3, "icon", 4, "ngIf"], ["class", "ml-2", 4, "ngIf"], [3, "icon"], [1, "ml-2"], ["class", "px-3 py-2", 3, "ngClass", "click", 4, "ngIf"], [1, "px-3", "py-2", 3, "ngClass", "click"], ["class", "mr-2", 4, "ngIf"], [1, "mr-2"]], template: function TabGroupControllerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul");
        ɵngcc0.ɵɵtemplate(1, TabGroupControllerComponent_li_1_Template, 3, 2, "li", 0);
        ɵngcc0.ɵɵtemplate(2, TabGroupControllerComponent_ng_container_2_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("tab-group-controller ", ctx.className, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.text || ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tabList);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc2.FaIconComponent, ɵngcc1.NgClass], encapsulation: 2 });
TabGroupControllerComponent.ctorParameters = () => [];
TabGroupControllerComponent.propDecorators = {
    tabList: [{ type: Input }],
    className: [{ type: Input }],
    text: [{ type: Input }],
    icon: [{ type: Input }],
    iconPrefix: [{ type: Input }],
    parentId: [{ type: Input }],
    consoleLogs: [{ type: Input }],
    userRole: [{ type: Input }],
    userSubRole: [{ type: Input }],
    emitter: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabGroupControllerComponent, [{
        type: Component,
        args: [{
                selector: 'ascedia-tab-group-controller',
                template: "\n<ul class=\"tab-group-controller {{className}}\">\n\t<li class=\"px-3 py-3 font-weight-bold\" *ngIf=\"text || icon\">\n\t\t<fa-icon *ngIf=\"icon\" [icon]=\"[iconPrefix, icon]\"></fa-icon>\n\t\t<span *ngIf=\"text\" class=\"ml-2\">{{text}}</span>\n\t</li>\n\n\t<!-- <div class=\"bred mb-3 small text-danger\">\n\t\t<div>userRole: {{userRole}}</div>\n\t\t<div>userSubRole: {{userSubRole}}</div>\n\t</div> -->\n\n\t<ng-container *ngFor=\"let tab of tabList;\">\n\t\t<!-- <div class=\"small text-danger\">{{tab.title}} - {{tab?.roles | json}} - {{tab?.subroles | json}}</div> -->\n\t\t<li *ngIf=\"(!tab.roles && !tab.subroles) || (tab.roles && tab.roles.includes(userRole) && !tab.subroles) || (tab.roles && tab.roles.includes(userRole) && tab.subroles && (!userSubRole || tab.subroles.includes(userSubRole)))\"\n\t\t\t(click)=\"tabClick(tab.id)\"\n\t\t\t[ngClass]=\"{'active': ((!parentId && tab.id == sectionActive) || (parentId && tab.id == sectionActiveSub)), 'disabled': tab.disabled}\"\n\t\t\tclass=\"px-3 py-2\"\n\t\t\t>\n\t\t\t<span *ngIf=\"(tab.icon && !tab.iconActive) || (tab.icon && tab.iconActive && ((!parentId && tab.id != sectionActive) || (parentId && tab.id != sectionActiveSub)))\" \n\t\t\t\tclass=\"mr-2\"><fa-icon [icon]=\"[tab.iconPrefix, tab.icon]\"></fa-icon></span>\n\t\t\t<span *ngIf=\"tab.iconActive && ((!parentId && tab.id == sectionActive) || (parentId && tab.id == sectionActiveSub))\"\n\t\t\t\tclass=\"mr-2\"><fa-icon [icon]=\"[tab.iconPrefixActive, tab.iconActive]\"></fa-icon></span>\n\t\t\t<span>{{tab.title}}</span>\n\t\t</li>\n\t</ng-container>\n</ul>"
            }]
    }], function () { return []; }, { tabList: [{
            type: Input
        }], className: [{
            type: Input
        }], text: [{
            type: Input
        }], icon: [{
            type: Input
        }], iconPrefix: [{
            type: Input
        }], parentId: [{
            type: Input
        }], consoleLogs: [{
            type: Input
        }], userRole: [{
            type: Input
        }], userSubRole: [{
            type: Input
        }], emitter: [{
            type: Output
        }] }); })();

class RedirectService {
    constructor(router, document) {
        this.router = router;
        this.document = document;
        //console.log('RedirectService.constructor');
    }
    /** The Window object from Document defaultView */
    get window() { return this.document.defaultView; } //Window
    /** Jumps instantly to the external link without the mediation of the router */
    jump(url, target = '_blank') {
        //console.log('RedirectService.jump().url', url);
        return new Promise((resolve, reject) => {
            try {
                resolve(!!this.window.open(url, target));
            }
            catch (e) {
                reject(e);
            }
        });
    }
    /** Returns true if the given url looks external */
    external(url) {
        if (url)
            url = url.toLowerCase();
        const isExternal = /^http(?:s)?:\/{2}\S+$/.test(url);
        //console.log('RedirectService.external().url', url, isExternal);
        //return /^http(?:s)?:\/{2}\S+$/.test(url);
        return isExternal;
    }
    /** Redirects to the specified external link with the mediation of the router */
    redirect(url, extras) {
        //console.log('RedirectService.redirect().url', url, extras);
        // Extracts the target from the extras
        const target = extras && extras.target;
        // Compose the url link for redirection
        const link = "/redirect?url=" + url + (!!target ? "&=" + target : '');
        // Navigates with the router activat the redirection guard
        return this.router.navigateByUrl(link, extras);
    }
    /** Navigates to the given url, redirecting when necessary
     * @param url An absolute URL. The function does not apply any delta to the current URL.
     * When starting with 'http(s)://' triggers the external redirection.
     * @param extras (optional). An object containing properties that modify the navigation strategy.
     * The function ignores any properties that would change the provided URL.
     */
    navigate(url, extras) {
        //console.log('RedirectService.navigate().url', url, extras);
        return this.external(url) ?
            // Redirects to external link
            //this.redirect(url, extras) : 
            this.jump(url) : //^^ the redirect stuff didn't work. it didnt' like the /redirect route
            // Navigates with the router otherwise 
            this.router.navigateByUrl(url, extras);
    }
    canActivate(route) {
        //console.log('RedirectService.canActivate().route', route);
        //TODO-JK: THIS ISN'T WORKING RIGHT YET. CAN ACTIVATE IS TRIGGERED, BUT IT'S AFTER THE REDIRECT TO 404 AND WE'VE LOST THE ORIGINAL URL PARAM.
        // this.route.queryParams
        // 	.subscribe(params => {
        // 		console.log('route.queryParams:', params); // { orderby: "price" }
        // 	}
        // );
        // Gets the url query parameter, if any
        const url = route.queryParamMap.get('url') ? String(route.queryParamMap.get('url')) : '';
        // If the url matches an external link, redirects stopping the route activation
        if (this.external(url)) {
            // Gets the optional target, when specified
            const target = route.queryParamMap.get('target') ? String(route.queryParamMap.get('target')) : '';
            // Jumps to the external resource
            return this.jump(url, target).then(() => false);
        }
        // Goes on activating the requested route, most likely to NotFound
        return true;
    }
}
RedirectService.ɵfac = function RedirectService_Factory(t) { return new (t || RedirectService)(ɵngcc0.ɵɵinject(ɵngcc3.Router), ɵngcc0.ɵɵinject(DOCUMENT)); };
RedirectService.ɵprov = i0.ɵɵdefineInjectable({ factory: function RedirectService_Factory() { return new RedirectService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.DOCUMENT)); }, token: RedirectService, providedIn: "root" });
RedirectService.ctorParameters = () => [
    { type: Router },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RedirectService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

class RedirectDirective {
    constructor(redirect) {
        this.redirect = redirect;
        this.url = '';
        /** */
        //@Input('disabled') set disable(value: boolean) { this.disabled = coerceBooleanProperty(value); }
        this.disabled = false;
    }
    onClick() {
        // Skips when disabled
        if (this.disabled) {
            return false;
        }
        if (this.url == '#') {
            //console.log('# dropdown menu, stop here.');
            return false;
        }
        // Navigates on the requested link redirecting when necessary
        this.redirect.navigate(this.url);
        // Prevents default
        return false;
    }
}
RedirectDirective.ɵfac = function RedirectDirective_Factory(t) { return new (t || RedirectDirective)(ɵngcc0.ɵɵdirectiveInject(RedirectService)); };
RedirectDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: RedirectDirective, selectors: [["", "wmRedirect", "", 5, "a", 5, "area"]], hostBindings: function RedirectDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function RedirectDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } }, inputs: { url: ["wmRedirect", "url"] } });
RedirectDirective.ctorParameters = () => [
    { type: RedirectService }
];
RedirectDirective.propDecorators = {
    url: [{ type: Input, args: ['wmRedirect',] }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RedirectDirective, [{
        type: Directive,
        args: [{
                selector: ':not(a):not(area)[wmRedirect]'
            }]
    }], function () { return [{ type: RedirectService }]; }, { url: [{
            type: Input,
            args: ['wmRedirect']
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();
class RedirectWithHrefDirective extends RedirectDirective {
    constructor(redirect) {
        super(redirect);
    }
    // Binds the requested url to the href property
    get href() { return this.url; }
}
RedirectWithHrefDirective.ɵfac = function RedirectWithHrefDirective_Factory(t) { return new (t || RedirectWithHrefDirective)(ɵngcc0.ɵɵdirectiveInject(RedirectService)); };
RedirectWithHrefDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: RedirectWithHrefDirective, selectors: [["a", "wmRedirect", ""], ["area", "wmRedirect", ""]], hostVars: 1, hostBindings: function RedirectWithHrefDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("href", ctx.href, ɵngcc0.ɵɵsanitizeUrl);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
RedirectWithHrefDirective.ctorParameters = () => [
    { type: RedirectService }
];
RedirectWithHrefDirective.propDecorators = {
    href: [{ type: HostBinding, args: ['href',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RedirectWithHrefDirective, [{
        type: Directive,
        args: [{
                selector: 'a[wmRedirect],area[wmRedirect]'
            }]
    }], function () { return [{ type: RedirectService }]; }, { href: [{
            type: HostBinding,
            args: ['href']
        }] }); })();

class AscediaDesignSystemModule {
    constructor(library) {
        library.addIcons(faCheckSquare);
        library.addIcons(faChevronDown);
        library.addIcons(faChevronLeft);
        library.addIcons(faChevronRight);
        library.addIcons(faChevronUp);
        library.addIcons(faCircle);
        library.addIcons(faCheckCircle);
        library.addIcons(faClone);
        library.addIcons(faCoffee);
        library.addIcons(faComments);
        library.addIcons(faGlobe);
        library.addIcons(faGlobeAmericas);
        library.addIcons(faHeart);
        //library.addIcons(fadHeart);
        library.addIcons(faHeart$1);
        library.addIcons(faFunnelDollar);
        library.addIcons(faLaptop);
        library.addIcons(faMapMarked);
        library.addIcons(faMinus);
        library.addIcons(faPen);
        library.addIcons(faPhoneVolume);
        library.addIcons(faPlus);
        library.addIcons(faPlus$1);
        library.addIcons(faSackDollar);
        library.addIcons(faSquare);
        library.addIcons(faShoppingCart);
        library.addIcons(faUser);
        library.addIcons(faUsers);
        library.addIcons(faUserCircle);
        library.addIcons(faUsersClass);
        library.addIcons(faUserTag);
        library.addIcons(faTags);
        library.addIcons(faTrashAlt);
        library.addIcons(faUmbrellaBeach);
        library.addIcons(faWrench);
    }
}
AscediaDesignSystemModule.ɵfac = function AscediaDesignSystemModule_Factory(t) { return new (t || AscediaDesignSystemModule)(ɵngcc0.ɵɵinject(ɵngcc2.FaIconLibrary)); };
AscediaDesignSystemModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AscediaDesignSystemModule });
AscediaDesignSystemModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [RedirectService], imports: [[
            CommonModule,
            FontAwesomeModule,
            ReactiveFormsModule,
            RouterModule,
            SwiperModule
        ]] });
AscediaDesignSystemModule.ctorParameters = () => [
    { type: FaIconLibrary }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AscediaDesignSystemModule, { declarations: function () { return [AccordionBasicComponent, AccordionTabGroupComponent, AlertBannerComponent, BreadcrumbsComponent, ButtonComponent, CheckboxFormGroupComponent, CheckboxGroupComponent, FileUploaderGroupComponent, HorizCardComponent, ImageGridComponent, InfoBoxAccordionComponent, JumbotronComponent, ListButtonComponent, ListButtonGroupComponent, LoadingStatusComponent, NavbarComponent, PaginationComponent, SwiperBackgroundImageComponent, SwiperCardImageComponent, SwiperJumbotronComponent, TabGroupControllerComponent, RedirectWithHrefDirective]; }, imports: function () { return [CommonModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        RouterModule,
        SwiperModule]; }, exports: function () { return [AccordionBasicComponent, AccordionTabGroupComponent, AlertBannerComponent, BreadcrumbsComponent, ButtonComponent, CheckboxFormGroupComponent, CheckboxGroupComponent, FileUploaderGroupComponent, HorizCardComponent, ImageGridComponent, JumbotronComponent, InfoBoxAccordionComponent, ListButtonComponent, ListButtonGroupComponent, LoadingStatusComponent, NavbarComponent, PaginationComponent, SwiperBackgroundImageComponent, SwiperCardImageComponent, SwiperJumbotronComponent, TabGroupControllerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AscediaDesignSystemModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AccordionBasicComponent,
                    AccordionTabGroupComponent,
                    AlertBannerComponent,
                    BreadcrumbsComponent,
                    ButtonComponent,
                    CheckboxFormGroupComponent,
                    CheckboxGroupComponent,
                    FileUploaderGroupComponent,
                    HorizCardComponent,
                    ImageGridComponent,
                    InfoBoxAccordionComponent,
                    JumbotronComponent,
                    ListButtonComponent,
                    ListButtonGroupComponent,
                    LoadingStatusComponent,
                    NavbarComponent,
                    PaginationComponent,
                    SwiperBackgroundImageComponent,
                    SwiperCardImageComponent,
                    SwiperJumbotronComponent,
                    TabGroupControllerComponent,
                    //DIRECTIVES
                    RedirectWithHrefDirective
                ],
                imports: [
                    CommonModule,
                    FontAwesomeModule,
                    ReactiveFormsModule,
                    RouterModule,
                    SwiperModule
                ],
                exports: [
                    AccordionBasicComponent,
                    AccordionTabGroupComponent,
                    AlertBannerComponent,
                    BreadcrumbsComponent,
                    ButtonComponent,
                    CheckboxFormGroupComponent,
                    CheckboxGroupComponent,
                    FileUploaderGroupComponent,
                    HorizCardComponent,
                    ImageGridComponent,
                    JumbotronComponent,
                    InfoBoxAccordionComponent,
                    ListButtonComponent,
                    ListButtonGroupComponent,
                    LoadingStatusComponent,
                    NavbarComponent,
                    PaginationComponent,
                    SwiperBackgroundImageComponent,
                    SwiperCardImageComponent,
                    SwiperJumbotronComponent,
                    TabGroupControllerComponent
                ],
                providers: [RedirectService]
            }]
    }], function () { return [{ type: ɵngcc2.FaIconLibrary }]; }, null); })();

/*
 * Public API Surface of ascedia-design-system
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionBasicComponent, AccordionTabGroupComponent, AlertBannerComponent, AscediaDesignSystemModule, BreadcrumbsComponent, ButtonComponent, CheckboxFormGroupComponent, CheckboxGroupComponent, FileUploaderGroupComponent, HorizCardComponent, ImageGridComponent, InfoBoxAccordionComponent, JumbotronComponent, ListButtonComponent, ListButtonGroupComponent, LoadingStatusComponent, NavbarComponent, PaginationComponent, SwiperBackgroundImageComponent, SwiperCardImageComponent, SwiperJumbotronComponent, TabGroupControllerComponent, RedirectDirective as ɵa, RedirectWithHrefDirective as ɵb, RedirectService as ɵc };

//# sourceMappingURL=ascedia-design-system.js.map